/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		3: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({}[chunkId]||chunkId) + ".chunk." + {"0":"9566e","1":"71cd7","2":"309f2"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "5D9O":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("wVGV")();
}

/***/ }),

/***/ "6N6E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9qb7":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),

/***/ "Asjh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./styles/main.css
var main = __webpack_require__("e1Qo");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// EXTERNAL MODULE: ./styles/github-banner.css
var github_banner = __webpack_require__("VSpX");
var github_banner_default = /*#__PURE__*/__webpack_require__.n(github_banner);

// CONCATENATED MODULE: ./components/github-banner.js



var github_banner__ref = Object(preact_min["h"])(
	"a",
	{ href: "https://github.com/tom-sherman/rainbird-rule-flames", "class": "github-corner", "aria-label": "View source on GitHub" },
	Object(preact_min["h"])(
		"svg",
		{ width: "80", height: "80", viewBox: "0 0 250 250", style: "fill:#151513; color:#fff; position: absolute; top: 0; border: 0; right: 0;", "aria-hidden": "true" },
		Object(preact_min["h"])("path", { d: "M0,0 L115,115 L130,115 L142,142 L250,250 L250,0 Z" }),
		Object(preact_min["h"])("path", { d: "M128.3,109.0 C113.8,99.7 119.0,89.6 119.0,89.6 C122.0,82.7 120.5,78.6 120.5,78.6 C119.2,72.0 123.4,76.3 123.4,76.3 C127.3,80.9 125.5,87.3 125.5,87.3 C122.9,97.6 130.6,101.9 134.4,103.2", fill: "currentColor", style: "transform-origin: 130px 106px;", "class": "octo-arm" }),
		Object(preact_min["h"])("path", { d: "M115.0,115.0 C114.9,115.1 118.7,116.5 119.8,115.4 L133.7,101.6 C136.9,99.2 139.9,98.4 142.2,98.6 C133.8,88.0 127.5,74.4 143.8,58.0 C148.5,53.4 154.0,51.2 159.7,51.0 C160.3,49.4 163.2,43.6 171.4,40.1 C171.4,40.1 176.1,42.5 178.8,56.2 C183.1,58.6 187.2,61.8 190.9,65.4 C194.5,69.0 197.7,73.2 200.1,77.6 C213.8,80.2 216.3,84.9 216.3,84.9 C212.7,93.1 206.9,96.0 205.4,96.6 C205.1,102.4 203.0,107.8 198.3,112.5 C181.9,128.9 168.3,122.5 157.7,114.1 C157.9,116.9 156.7,120.9 152.7,124.9 L141.0,136.5 C139.8,137.7 141.6,141.9 141.8,141.8 Z", fill: "currentColor", "class": "octo-body" })
	)
);

function GithubBanner() {
	return github_banner__ref;
}
// CONCATENATED MODULE: ./components/json-input.js

function JsonInput(_ref) {
	var placeHolder = _ref.placeHolder,
	    handleJsonChange = _ref.handleJsonChange;

	return Object(preact_min["h"])("textarea", {
		placeholder: placeHolder,
		onInput: handleJsonChange
	});
}
// CONCATENATED MODULE: ./util.js
/**
 * @param {Intl.NumberFormat?} formatter
 * @param {number?} value
 */
function formatNumber(formatter, value) {
  return formatter instanceof Intl.NumberFormat && !isNaN(value) ? formatter.format(value) : value;
}

function formatTime(formatter, value) {
  var inputFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ns';

  return inputFormat === 'ns' ? formatNumber(formatter, value / 1000000) : formatNumber(formatter, value); // 1000000 nanoseonds in a miliseconds
}

function hslToHex(h, s, l) {
  h /= 360;
  s /= 100;
  l /= 100;
  var r = void 0,
      g = void 0,
      b = void 0;
  if (s === 0) {
    r = g = b = l; // achromatic
  } else {
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hueToRgb(p, q, h + 1 / 3);
    g = hueToRgb(p, q, h);
    b = hueToRgb(p, q, h - 1 / 3);
  }
  return '#' + toHex(r) + toHex(g) + toHex(b);
}

function toHex(x) {
  return Math.round(x * 255).toString(16).padStart(2, '0');
}

function hueToRgb(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}
// CONCATENATED MODULE: ./components/table/table-item-number.js



var table_item_number__ref2 = Object(preact_min["h"])(
	'span',
	{ 'class': 'bold' },
	'-'
);

function TableItemNumber(_ref) {
	var value = _ref.value,
	    title = _ref.title,
	    numberFormat = _ref.numberFormat,
	    children = _ref.children,
	    bold = _ref.bold;

	if (!value || isNaN(value)) {
		return table_item_number__ref2;
	}
	return Object(preact_min["h"])(
		'span',
		{ 'class': bold ? 'bold' : null, title: title ? formatNumber(numberFormat, value) : null },
		children.length ? children : formatNumber(numberFormat, value)
	);
}
// CONCATENATED MODULE: ./components/table/table-item-time.js




var table_item_time__ref2 = Object(preact_min["h"])('span', { 'class': 'time-unit' });

function TableItemTime(_ref) {
	var value = _ref.value,
	    numberFormat = _ref.numberFormat,
	    inputFormat = _ref.inputFormat,
	    bold = _ref.bold;

	return Object(preact_min["h"])(
		TableItemNumber,
		{ title: true, value: value, numberFormat: numberFormat, bold: bold },
		formatTime(numberFormat, value, inputFormat),
		table_item_time__ref2
	);
}
// CONCATENATED MODULE: ./components/table/index.js


// CONCATENATED MODULE: ./components/summary-table.js



var summary_table__ref2 = Object(preact_min["h"])(
	"td",
	null,
	"Evidence Tree"
);

var summary_table__ref3 = Object(preact_min["h"])(
	"td",
	null,
	"Total time"
);

var summary_table__ref4 = Object(preact_min["h"])(
	"td",
	null,
	"Approx engine time"
);

var summary_table__ref5 = Object(preact_min["h"])(
	"td",
	null,
	"Total condition count"
);

var summary_table__ref6 = Object(preact_min["h"])(
	"td",
	null,
	"Calls to datasources"
);

var summary_table__ref7 = Object(preact_min["h"])(
	"td",
	null,
	"Total datasource time"
);

function SummaryTable(_ref) {
	var evidenceTree = _ref.evidenceTree,
	    totalMs = _ref.totalMs,
	    engineTime = _ref.engineTime,
	    totalConditionCount = _ref.totalConditionCount,
	    callDatasourceCount = _ref.callDatasourceCount,
	    callDatasourceTime = _ref.callDatasourceTime,
	    numberFormat = _ref.numberFormat;

	return Object(preact_min["h"])(
		"table",
		null,
		Object(preact_min["h"])(
			"tbody",
			null,
			Object(preact_min["h"])(
				"tr",
				null,
				summary_table__ref2,
				Object(preact_min["h"])(
					"td",
					null,
					evidenceTree ? Object(preact_min["h"])(
						"a",
						{ href: evidenceTree, target: "_blank", rel: "noopener noreferrer" },
						"Link"
					) : '-'
				)
			),
			Object(preact_min["h"])(
				"tr",
				null,
				summary_table__ref3,
				Object(preact_min["h"])(
					"td",
					null,
					Object(preact_min["h"])(TableItemTime, { value: totalMs, inputFormat: "ms", bold: true, numberFormat: numberFormat })
				)
			),
			Object(preact_min["h"])(
				"tr",
				null,
				summary_table__ref4,
				Object(preact_min["h"])(
					"td",
					null,
					Object(preact_min["h"])(TableItemTime, { value: engineTime, inputFormat: "ms", bold: true, numberFormat: numberFormat })
				)
			),
			Object(preact_min["h"])(
				"tr",
				null,
				summary_table__ref5,
				Object(preact_min["h"])(
					"td",
					null,
					Object(preact_min["h"])(TableItemNumber, { value: totalConditionCount, bold: true, numberFormat: numberFormat })
				)
			),
			Object(preact_min["h"])(
				"tr",
				null,
				summary_table__ref6,
				Object(preact_min["h"])(
					"td",
					null,
					Object(preact_min["h"])(TableItemNumber, { value: callDatasourceCount, bold: true, numberFormat: numberFormat })
				)
			),
			Object(preact_min["h"])(
				"tr",
				null,
				summary_table__ref7,
				Object(preact_min["h"])(
					"td",
					null,
					Object(preact_min["h"])(TableItemTime, { value: callDatasourceTime, bold: true, numberFormat: numberFormat, inputFormat: "ms" })
				)
			)
		)
	);
}
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__("5D9O");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ../node_modules/preact-compat/dist/preact-compat.es.js




var version = '15.1.0'; // trick libraries to think we are react

var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');

var REACT_ELEMENT_TYPE = typeof Symbol !== 'undefined' && Symbol.for && Symbol.for('react.element') || 0xeac7;

var COMPONENT_WRAPPER_KEY = typeof Symbol !== 'undefined' && Symbol.for ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';

// don't autobind these methods since they already have guaranteed context.
var AUTOBIND_BLACKLIST = {
	constructor: 1,
	render: 1,
	shouldComponentUpdate: 1,
	componentWillReceiveProps: 1,
	componentWillUpdate: 1,
	componentDidUpdate: 1,
	componentWillMount: 1,
	componentDidMount: 1,
	componentWillUnmount: 1,
	componentDidUnmount: 1
};

var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;

var BYPASS_HOOK = {};

/*global process*/
var DEV = false;
try {
	DEV = "production" !== 'production';
} catch (e) {}

// a component that renders nothing. Used to replace components for unmountComponentAtNode.
function EmptyComponent() {
	return null;
}

// make react think we're react.
var VNode = Object(preact_min["h"])('a', null).constructor;
VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
VNode.prototype.preactCompatUpgraded = false;
VNode.prototype.preactCompatNormalized = false;

Object.defineProperty(VNode.prototype, 'type', {
	get: function get() {
		return this.nodeName;
	},
	set: function set(v) {
		this.nodeName = v;
	},
	configurable: true
});

Object.defineProperty(VNode.prototype, 'props', {
	get: function get() {
		return this.attributes;
	},
	set: function set(v) {
		this.attributes = v;
	},
	configurable: true
});

var oldEventHook = preact_min["options"].event;
preact_min["options"].event = function (e) {
	if (oldEventHook) {
		e = oldEventHook(e);
	}
	e.persist = Object;
	e.nativeEvent = e;
	return e;
};

var oldVnodeHook = preact_min["options"].vnode;
preact_min["options"].vnode = function (vnode) {
	if (!vnode.preactCompatUpgraded) {
		vnode.preactCompatUpgraded = true;

		var tag = vnode.nodeName,
		    attrs = vnode.attributes = vnode.attributes == null ? {} : extend({}, vnode.attributes);

		if (typeof tag === 'function') {
			if (tag[COMPONENT_WRAPPER_KEY] === true || tag.prototype && 'isReactComponent' in tag.prototype) {
				if (vnode.children && String(vnode.children) === '') {
					vnode.children = undefined;
				}
				if (vnode.children) {
					attrs.children = vnode.children;
				}

				if (!vnode.preactCompatNormalized) {
					normalizeVNode(vnode);
				}
				handleComponentVNode(vnode);
			}
		} else {
			if (vnode.children && String(vnode.children) === '') {
				vnode.children = undefined;
			}
			if (vnode.children) {
				attrs.children = vnode.children;
			}

			if (attrs.defaultValue) {
				if (!attrs.value && attrs.value !== 0) {
					attrs.value = attrs.defaultValue;
				}
				delete attrs.defaultValue;
			}

			handleElementVNode(vnode, attrs);
		}
	}

	if (oldVnodeHook) {
		oldVnodeHook(vnode);
	}
};

function handleComponentVNode(vnode) {
	var tag = vnode.nodeName,
	    a = vnode.attributes;

	vnode.attributes = {};
	if (tag.defaultProps) {
		extend(vnode.attributes, tag.defaultProps);
	}
	if (a) {
		extend(vnode.attributes, a);
	}
}

function handleElementVNode(vnode, a) {
	var shouldSanitize, attrs, i;
	if (a) {
		for (i in a) {
			if (shouldSanitize = CAMEL_PROPS.test(i)) {
				break;
			}
		}
		if (shouldSanitize) {
			attrs = vnode.attributes = {};
			for (i in a) {
				if (a.hasOwnProperty(i)) {
					attrs[CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i] = a[i];
				}
			}
		}
	}
}

// proxy render() since React returns a Component reference.
function render$1(vnode, parent, callback) {
	var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;

	// ignore impossible previous renders
	if (prev && prev.parentNode !== parent) {
		prev = null;
	}

	// default to first Element child
	if (!prev && parent) {
		prev = parent.firstElementChild;
	}

	// remove unaffected siblings
	for (var i = parent.childNodes.length; i--;) {
		if (parent.childNodes[i] !== prev) {
			parent.removeChild(parent.childNodes[i]);
		}
	}

	var out = Object(preact_min["render"])(vnode, parent, prev);
	if (parent) {
		parent._preactCompatRendered = out && (out._component || { base: out });
	}
	if (typeof callback === 'function') {
		callback();
	}
	return out && out._component || out;
}

var ContextProvider = function ContextProvider() {};

ContextProvider.prototype.getChildContext = function () {
	return this.props.context;
};
ContextProvider.prototype.render = function (props) {
	return props.children[0];
};

function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
	var wrap = Object(preact_min["h"])(ContextProvider, { context: parentComponent.context }, vnode);
	var renderContainer = render$1(wrap, container);
	var component = renderContainer._component || renderContainer.base;
	if (callback) {
		callback.call(component, renderContainer);
	}
	return component;
}

function Portal(props) {
	renderSubtreeIntoContainer(this, props.vnode, props.container);
}

function createPortal(vnode, container) {
	return Object(preact_min["h"])(Portal, { vnode: vnode, container: container });
}

function unmountComponentAtNode(container) {
	var existing = container._preactCompatRendered && container._preactCompatRendered.base;
	if (existing && existing.parentNode === container) {
		Object(preact_min["render"])(Object(preact_min["h"])(EmptyComponent), container, existing);
		return true;
	}
	return false;
}

var ARR = [];

// This API is completely unnecessary for Preact, so it's basically passthrough.
var Children = {
	map: function map(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		return children.map(fn);
	},
	forEach: function forEach(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		children.forEach(fn);
	},
	count: function count(children) {
		return children && children.length || 0;
	},
	only: function only(children) {
		children = Children.toArray(children);
		if (children.length !== 1) {
			throw new Error('Children.only() expects only one child.');
		}
		return children[0];
	},
	toArray: function toArray(children) {
		if (children == null) {
			return [];
		}
		return ARR.concat(children);
	}
};

/** Track current render() component for ref assignment */
var currentComponent;

function createFactory(type) {
	return createElement.bind(null, type);
}

var DOM = {};
for (var preact_compat_es_i = ELEMENTS.length; preact_compat_es_i--;) {
	DOM[ELEMENTS[preact_compat_es_i]] = createFactory(ELEMENTS[preact_compat_es_i]);
}

function upgradeToVNodes(arr, offset) {
	for (var i = offset || 0; i < arr.length; i++) {
		var obj = arr[i];
		if (Array.isArray(obj)) {
			upgradeToVNodes(obj);
		} else if (obj && typeof obj === 'object' && !isValidElement(obj) && (obj.props && obj.type || obj.attributes && obj.nodeName || obj.children)) {
			arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
		}
	}
}

function isStatelessComponent(c) {
	return typeof c === 'function' && !(c.prototype && c.prototype.render);
}

// wraps stateless functional components in a PropTypes validator
function wrapStatelessComponent(WrappedComponent) {
	return createClass({
		displayName: WrappedComponent.displayName || WrappedComponent.name,
		render: function render() {
			return WrappedComponent(this.props, this.context);
		}
	});
}

function statelessComponentHook(Ctor) {
	var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
	if (Wrapped) {
		return Wrapped === true ? Ctor : Wrapped;
	}

	Wrapped = wrapStatelessComponent(Ctor);

	Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, { configurable: true, value: true });
	Wrapped.displayName = Ctor.displayName;
	Wrapped.propTypes = Ctor.propTypes;
	Wrapped.defaultProps = Ctor.defaultProps;

	Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, { configurable: true, value: Wrapped });

	return Wrapped;
}

function createElement() {
	var args = [],
	    len = arguments.length;
	while (len--) {
		args[len] = arguments[len];
	}upgradeToVNodes(args, 2);
	return normalizeVNode(preact_min["h"].apply(void 0, args));
}

function normalizeVNode(vnode) {
	vnode.preactCompatNormalized = true;

	applyClassName(vnode);

	if (isStatelessComponent(vnode.nodeName)) {
		vnode.nodeName = statelessComponentHook(vnode.nodeName);
	}

	var ref = vnode.attributes.ref,
	    type = ref && typeof ref;
	if (currentComponent && (type === 'string' || type === 'number')) {
		vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
	}

	applyEventNormalization(vnode);

	return vnode;
}

function cloneElement$1(element, props) {
	var children = [],
	    len = arguments.length - 2;
	while (len-- > 0) {
		children[len] = arguments[len + 2];
	}if (!isValidElement(element)) {
		return element;
	}
	var elementProps = element.attributes || element.props;
	var node = Object(preact_min["h"])(element.nodeName || element.type, extend({}, elementProps), element.children || elementProps && elementProps.children);
	// Only provide the 3rd argument if needed.
	// Arguments 3+ overwrite element.children in preactCloneElement
	var cloneArgs = [node, props];
	if (children && children.length) {
		cloneArgs.push(children);
	} else if (props && props.children) {
		cloneArgs.push(props.children);
	}
	return normalizeVNode(preact_min["cloneElement"].apply(void 0, cloneArgs));
}

function isValidElement(element) {
	return element && (element instanceof VNode || element.$$typeof === REACT_ELEMENT_TYPE);
}

function createStringRefProxy(name, component) {
	return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
		if (component && component.refs) {
			component.refs[name] = resolved;
			if (resolved === null) {
				delete component._refProxies[name];
				component = null;
			}
		}
	});
}

function applyEventNormalization(ref) {
	var nodeName = ref.nodeName;
	var attributes = ref.attributes;

	if (!attributes || typeof nodeName !== 'string') {
		return;
	}
	var props = {};
	for (var i in attributes) {
		props[i.toLowerCase()] = i;
	}
	if (props.ondoubleclick) {
		attributes.ondblclick = attributes[props.ondoubleclick];
		delete attributes[props.ondoubleclick];
	}
	// for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
	if (props.onchange && (nodeName === 'textarea' || nodeName.toLowerCase() === 'input' && !/^fil|che|rad/i.test(attributes.type))) {
		var normalized = props.oninput || 'oninput';
		if (!attributes[normalized]) {
			attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
			delete attributes[props.onchange];
		}
	}
}

function applyClassName(vnode) {
	var a = vnode.attributes || (vnode.attributes = {});
	classNameDescriptor.enumerable = 'className' in a;
	if (a.className) {
		a.class = a.className;
	}
	Object.defineProperty(a, 'className', classNameDescriptor);
}

var classNameDescriptor = {
	configurable: true,
	get: function get() {
		return this.class;
	},
	set: function set(v) {
		this.class = v;
	}
};

function extend(base, props) {
	var arguments$1 = arguments;

	for (var i = 1, obj = void 0; i < arguments.length; i++) {
		if (obj = arguments$1[i]) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					base[key] = obj[key];
				}
			}
		}
	}
	return base;
}

function shallowDiffers(a, b) {
	for (var i in a) {
		if (!(i in b)) {
			return true;
		}
	}
	for (var i$1 in b) {
		if (a[i$1] !== b[i$1]) {
			return true;
		}
	}
	return false;
}

function findDOMNode(component) {
	return component && (component.base || component.nodeType === 1 && component) || null;
}

function F() {}

function createClass(obj) {
	function cl(props, context) {
		bindAll(this);
		Component$1.call(this, props, context, BYPASS_HOOK);
		newComponentHook.call(this, props, context);
	}

	obj = extend({ constructor: cl }, obj);

	// We need to apply mixins here so that getDefaultProps is correctly mixed
	if (obj.mixins) {
		applyMixins(obj, collateMixins(obj.mixins));
	}
	if (obj.statics) {
		extend(cl, obj.statics);
	}
	if (obj.propTypes) {
		cl.propTypes = obj.propTypes;
	}
	if (obj.defaultProps) {
		cl.defaultProps = obj.defaultProps;
	}
	if (obj.getDefaultProps) {
		cl.defaultProps = obj.getDefaultProps.call(cl);
	}

	F.prototype = Component$1.prototype;
	cl.prototype = extend(new F(), obj);

	cl.displayName = obj.displayName || 'Component';

	return cl;
}

// Flatten an Array of mixins to a map of method name to mixin implementations
function collateMixins(mixins) {
	var keyed = {};
	for (var i = 0; i < mixins.length; i++) {
		var mixin = mixins[i];
		for (var key in mixin) {
			if (mixin.hasOwnProperty(key) && typeof mixin[key] === 'function') {
				(keyed[key] || (keyed[key] = [])).push(mixin[key]);
			}
		}
	}
	return keyed;
}

// apply a mapping of Arrays of mixin methods to a component prototype
function applyMixins(proto, mixins) {
	for (var key in mixins) {
		if (mixins.hasOwnProperty(key)) {
			proto[key] = multihook(mixins[key].concat(proto[key] || ARR), key === 'getDefaultProps' || key === 'getInitialState' || key === 'getChildContext');
		}
	}
}

function bindAll(ctx) {
	for (var i in ctx) {
		var v = ctx[i];
		if (typeof v === 'function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
			(ctx[i] = v.bind(ctx)).__bound = true;
		}
	}
}

function callMethod(ctx, m, args) {
	if (typeof m === 'string') {
		m = ctx.constructor.prototype[m];
	}
	if (typeof m === 'function') {
		return m.apply(ctx, args);
	}
}

function multihook(hooks, skipDuplicates) {
	return function () {
		var arguments$1 = arguments;
		var this$1 = this;

		var ret;
		for (var i = 0; i < hooks.length; i++) {
			var r = callMethod(this$1, hooks[i], arguments$1);

			if (skipDuplicates && r != null) {
				if (!ret) {
					ret = {};
				}
				for (var key in r) {
					if (r.hasOwnProperty(key)) {
						ret[key] = r[key];
					}
				}
			} else if (typeof r !== 'undefined') {
				ret = r;
			}
		}
		return ret;
	};
}

function newComponentHook(props, context) {
	propsHook.call(this, props, context);
	this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
	this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
}

function propsHook(props, context) {
	if (!props) {
		return;
	}

	// React annoyingly special-cases single children, and some react components are ridiculously strict about this.
	var c = props.children;
	if (c && Array.isArray(c) && c.length === 1 && (typeof c[0] === 'string' || typeof c[0] === 'function' || c[0] instanceof VNode)) {
		props.children = c[0];

		// but its totally still going to be an Array.
		if (props.children && typeof props.children === 'object') {
			props.children.length = 1;
			props.children[0] = props.children;
		}
	}

	// add proptype checking
	if (DEV) {
		var ctor = typeof this === 'function' ? this : this.constructor,
		    propTypes = this.propTypes || ctor.propTypes;
		var displayName = this.displayName || ctor.name;

		if (propTypes) {
			prop_types_default.a.checkPropTypes(propTypes, props, 'prop', displayName);
		}
	}
}

function beforeRender(props) {
	currentComponent = this;
}

function afterRender() {
	if (currentComponent === this) {
		currentComponent = null;
	}
}

function Component$1(props, context, opts) {
	preact_min["Component"].call(this, props, context);
	this.state = this.getInitialState ? this.getInitialState() : {};
	this.refs = {};
	this._refProxies = {};
	if (opts !== BYPASS_HOOK) {
		newComponentHook.call(this, props, context);
	}
}
extend(Component$1.prototype = new preact_min["Component"](), {
	constructor: Component$1,

	isReactComponent: {},

	replaceState: function replaceState(state, callback) {
		var this$1 = this;

		this.setState(state, callback);
		for (var i in this$1.state) {
			if (!(i in state)) {
				delete this$1.state[i];
			}
		}
	},

	getDOMNode: function getDOMNode() {
		return this.base;
	},

	isMounted: function isMounted() {
		return !!this.base;
	}
});

function PureComponent(props, context) {
	Component$1.call(this, props, context);
}
F.prototype = Component$1.prototype;
PureComponent.prototype = new F();
PureComponent.prototype.isPureReactComponent = true;
PureComponent.prototype.shouldComponentUpdate = function (props, state) {
	return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
};

function unstable_batchedUpdates(callback) {
	callback();
}

var preact_compat_es_index = {
	version: version,
	DOM: DOM,
	PropTypes: prop_types_default.a,
	Children: Children,
	render: render$1,
	createClass: createClass,
	createPortal: createPortal,
	createFactory: createFactory,
	createElement: createElement,
	cloneElement: cloneElement$1,
	isValidElement: isValidElement,
	findDOMNode: findDOMNode,
	unmountComponentAtNode: unmountComponentAtNode,
	Component: Component$1,
	PureComponent: PureComponent,
	unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer,
	unstable_batchedUpdates: unstable_batchedUpdates,
	__spread: extend
};

/* harmony default export */ var preact_compat_es = (preact_compat_es_index);

//# sourceMappingURL=preact-compat.es.js.map
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__("9qb7");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ../node_modules/react-table/es/utils.js
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}



//
/* harmony default export */ var utils = ({
  get: get,
  set: set,
  takeRight: takeRight,
  last: last,
  orderBy: orderBy,
  range: range,
  remove: remove,
  clone: clone,
  getFirstDefined: getFirstDefined,
  sum: sum,
  makeTemplateComponent: makeTemplateComponent,
  groupBy: groupBy,
  isArray: isArray,
  splitProps: splitProps,
  compactObject: compactObject,
  isSortingDesc: isSortingDesc,
  normalizeComponent: normalizeComponent,
  asPx: asPx
});

function get(obj, path, def) {
  if (!path) {
    return obj;
  }
  var pathObj = makePathArray(path);
  var val = void 0;
  try {
    val = pathObj.reduce(function (current, pathPart) {
      return current[pathPart];
    }, obj);
  } catch (e) {
    // continue regardless of error
  }
  return typeof val !== 'undefined' ? val : def;
}

function set() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var path = arguments[1];
  var value = arguments[2];

  var keys = makePathArray(path);
  var keyPart = void 0;
  var cursor = obj;
  while ((keyPart = keys.shift()) && keys.length) {
    if (!cursor[keyPart]) {
      cursor[keyPart] = {};
    }
    cursor = cursor[keyPart];
  }
  cursor[keyPart] = value;
  return obj;
}

function takeRight(arr, n) {
  var start = n > arr.length ? 0 : arr.length - n;
  return arr.slice(start);
}

function last(arr) {
  return arr[arr.length - 1];
}

function range(n) {
  var arr = [];
  for (var i = 0; i < n; i += 1) {
    arr.push(n);
  }
  return arr;
}

function orderBy(arr, funcs, dirs, indexKey) {
  return arr.sort(function (rowA, rowB) {
    for (var i = 0; i < funcs.length; i += 1) {
      var comp = funcs[i];
      var desc = dirs[i] === false || dirs[i] === 'desc';
      var sortInt = comp(rowA, rowB);
      if (sortInt) {
        return desc ? -sortInt : sortInt;
      }
    }
    // Use the row index for tie breakers
    return dirs[0] ? rowA[indexKey] - rowB[indexKey] : rowB[indexKey] - rowA[indexKey];
  });
}

function remove(a, b) {
  return a.filter(function (o, i) {
    var r = b(o);
    if (r) {
      a.splice(i, 1);
      return true;
    }
    return false;
  });
}

function clone(a) {
  try {
    return JSON.parse(JSON.stringify(a, function (key, value) {
      if (typeof value === 'function') {
        return value.toString();
      }
      return value;
    }));
  } catch (e) {
    return a;
  }
}

function getFirstDefined() {
  for (var i = 0; i < arguments.length; i += 1) {
    if (typeof (arguments.length <= i ? undefined : arguments[i]) !== 'undefined') {
      return arguments.length <= i ? undefined : arguments[i];
    }
  }
}

function sum(arr) {
  return arr.reduce(function (a, b) {
    return a + b;
  }, 0);
}

function makeTemplateComponent(compClass, displayName) {
  if (!displayName) {
    throw new Error('No displayName found for template component:', compClass);
  }
  var cmp = function cmp(_ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = _objectWithoutProperties(_ref, ['children', 'className']);

    return preact_compat_es.createElement('div', _extends({ className: classnames_default()(compClass, className) }, rest), children);
  };
  cmp.displayName = displayName;
  return cmp;
}

function groupBy(xs, key) {
  return xs.reduce(function (rv, x, i) {
    var resKey = typeof key === 'function' ? key(x, i) : x[key];
    rv[resKey] = isArray(rv[resKey]) ? rv[resKey] : [];
    rv[resKey].push(x);
    return rv;
  }, {});
}

function asPx(value) {
  value = Number(value);
  return Number.isNaN(value) ? null : value + 'px';
}

function isArray(a) {
  return Array.isArray(a);
}

// ########################################################################
// Non-exported Helpers
// ########################################################################

function makePathArray(obj) {
  return flattenDeep(obj).join('.').replace(/\[/g, '.').replace(/\]/g, '').split('.');
}

function flattenDeep(arr) {
  var newArr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (!isArray(arr)) {
    newArr.push(arr);
  } else {
    for (var i = 0; i < arr.length; i += 1) {
      flattenDeep(arr[i], newArr);
    }
  }
  return newArr;
}

function splitProps(_ref2) {
  var className = _ref2.className,
      style = _ref2.style,
      rest = _objectWithoutProperties(_ref2, ['className', 'style']);

  return {
    className: className,
    style: style,
    rest: rest || {}
  };
}

function compactObject(obj) {
  var newObj = {};
  if (obj) {
    Object.keys(obj).map(function (key) {
      if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== undefined && typeof obj[key] !== 'undefined') {
        newObj[key] = obj[key];
      }
      return true;
    });
  }
  return newObj;
}

function isSortingDesc(d) {
  return !!(d.sort === 'desc' || d.desc === true || d.asc === false);
}

function normalizeComponent(Comp) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Comp;

  return typeof Comp === 'function' ? Object.getPrototypeOf(Comp).isReactComponent ? preact_compat_es.createElement(Comp, params) : Comp(params) : fallback;
}
// CONCATENATED MODULE: ../node_modules/react-table/es/lifecycle.js
var lifecycle__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/* harmony default export */ var lifecycle = (function (Base) {
  return function (_Base) {
    _inherits(_class, _Base);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.setStateWithData(this.getDataModel(this.getResolvedState(), true));
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.fireFetchData();
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextState) {
        var oldState = this.getResolvedState();
        var newState = this.getResolvedState(nextProps, nextState);

        // Do a deep compare of new and old `defaultOption` and
        // if they are different reset `option = defaultOption`
        var defaultableOptions = ['sorted', 'filtered', 'resized', 'expanded'];
        defaultableOptions.forEach(function (x) {
          var defaultName = 'default' + (x.charAt(0).toUpperCase() + x.slice(1));
          if (JSON.stringify(oldState[defaultName]) !== JSON.stringify(newState[defaultName])) {
            newState[x] = newState[defaultName];
          }
        });

        // If they change these table options, we need to reset defaults
        // or else we could get into a state where the user has changed the UI
        // and then disabled the ability to change it back.
        // e.g. If `filterable` has changed, set `filtered = defaultFiltered`
        var resettableOptions = ['sortable', 'filterable', 'resizable'];
        resettableOptions.forEach(function (x) {
          if (oldState[x] !== newState[x]) {
            var baseName = x.replace('able', '');
            var optionName = baseName + 'ed';
            var defaultName = 'default' + (optionName.charAt(0).toUpperCase() + optionName.slice(1));
            newState[optionName] = newState[defaultName];
          }
        });

        // Props that trigger a data update
        if (oldState.data !== newState.data || oldState.columns !== newState.columns || oldState.pivotBy !== newState.pivotBy || oldState.sorted !== newState.sorted || oldState.filtered !== newState.filtered) {
          this.setStateWithData(this.getDataModel(newState, oldState.data !== newState.data));
        }
      }
    }, {
      key: 'setStateWithData',
      value: function setStateWithData(newState, cb) {
        var _this2 = this;

        var oldState = this.getResolvedState();
        var newResolvedState = this.getResolvedState({}, newState);
        var freezeWhenExpanded = newResolvedState.freezeWhenExpanded;

        // Default to unfrozen state

        newResolvedState.frozen = false;

        // If freezeWhenExpanded is set, check for frozen conditions
        if (freezeWhenExpanded) {
          // if any rows are expanded, freeze the existing data and sorting
          var keys = Object.keys(newResolvedState.expanded);
          for (var i = 0; i < keys.length; i += 1) {
            if (newResolvedState.expanded[keys[i]]) {
              newResolvedState.frozen = true;
              break;
            }
          }
        }

        // If the data isn't frozen and either the data or
        // sorting model has changed, update the data
        if (oldState.frozen && !newResolvedState.frozen || oldState.sorted !== newResolvedState.sorted || oldState.filtered !== newResolvedState.filtered || oldState.showFilters !== newResolvedState.showFilters || !newResolvedState.frozen && oldState.resolvedData !== newResolvedState.resolvedData) {
          // Handle collapseOnsortedChange & collapseOnDataChange
          if (oldState.sorted !== newResolvedState.sorted && this.props.collapseOnSortingChange || oldState.filtered !== newResolvedState.filtered || oldState.showFilters !== newResolvedState.showFilters || oldState.sortedData && !newResolvedState.frozen && oldState.resolvedData !== newResolvedState.resolvedData && this.props.collapseOnDataChange) {
            newResolvedState.expanded = {};
          }

          lifecycle__extends(newResolvedState, this.getSortedData(newResolvedState));
        }

        // Set page to 0 if filters change
        if (oldState.filtered !== newResolvedState.filtered) {
          newResolvedState.page = 0;
        }

        // Calculate pageSize all the time
        if (newResolvedState.sortedData) {
          newResolvedState.pages = newResolvedState.manual ? newResolvedState.pages : Math.ceil(newResolvedState.sortedData.length / newResolvedState.pageSize);
          newResolvedState.page = Math.max(newResolvedState.page >= newResolvedState.pages ? newResolvedState.pages - 1 : newResolvedState.page, 0);
        }

        return this.setState(newResolvedState, function () {
          if (cb) {
            cb();
          }
          if (oldState.page !== newResolvedState.page || oldState.pageSize !== newResolvedState.pageSize || oldState.sorted !== newResolvedState.sorted || oldState.filtered !== newResolvedState.filtered) {
            _this2.fireFetchData();
          }
        });
      }
    }]);

    return _class;
  }(Base);
});
// CONCATENATED MODULE: ../node_modules/react-table/es/methods.js
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var methods__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var methods__createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

function methods__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function methods__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function methods__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}




/* harmony default export */ var methods = (function (Base) {
  return function (_Base) {
    methods__inherits(_class, _Base);

    function _class() {
      methods__classCallCheck(this, _class);

      return methods__possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    methods__createClass(_class, [{
      key: 'getResolvedState',
      value: function getResolvedState(props, state) {
        var resolvedState = methods__extends({}, utils.compactObject(this.state), utils.compactObject(this.props), utils.compactObject(state), utils.compactObject(props));
        return resolvedState;
      }
    }, {
      key: 'getDataModel',
      value: function getDataModel(newState, dataChanged) {
        var _this2 = this;

        var columns = newState.columns,
            _newState$pivotBy = newState.pivotBy,
            pivotBy = _newState$pivotBy === undefined ? [] : _newState$pivotBy,
            data = newState.data,
            resolveData = newState.resolveData,
            pivotIDKey = newState.pivotIDKey,
            pivotValKey = newState.pivotValKey,
            subRowsKey = newState.subRowsKey,
            aggregatedKey = newState.aggregatedKey,
            nestingLevelKey = newState.nestingLevelKey,
            originalKey = newState.originalKey,
            indexKey = newState.indexKey,
            groupedByPivotKey = newState.groupedByPivotKey,
            SubComponent = newState.SubComponent;

        // Determine Header Groups

        var hasHeaderGroups = false;
        columns.forEach(function (column) {
          if (column.columns) {
            hasHeaderGroups = true;
          }
        });

        var columnsWithExpander = [].concat(_toConsumableArray(columns));

        var expanderColumn = columns.find(function (col) {
          return col.expander || col.columns && col.columns.some(function (col2) {
            return col2.expander;
          });
        });
        // The actual expander might be in the columns field of a group column
        if (expanderColumn && !expanderColumn.expander) {
          expanderColumn = expanderColumn.columns.find(function (col) {
            return col.expander;
          });
        }

        // If we have SubComponent's we need to make sure we have an expander column
        if (SubComponent && !expanderColumn) {
          expanderColumn = { expander: true };
          columnsWithExpander = [expanderColumn].concat(_toConsumableArray(columnsWithExpander));
        }

        var makeDecoratedColumn = function makeDecoratedColumn(column, parentColumn) {
          var dcol = void 0;
          if (column.expander) {
            dcol = methods__extends({}, _this2.props.column, _this2.props.expanderDefaults, column);
          } else {
            dcol = methods__extends({}, _this2.props.column, column);
          }

          // Ensure minWidth is not greater than maxWidth if set
          if (dcol.maxWidth < dcol.minWidth) {
            dcol.minWidth = dcol.maxWidth;
          }

          if (parentColumn) {
            dcol.parentColumn = parentColumn;
          }

          // First check for string accessor
          if (typeof dcol.accessor === 'string') {
            dcol.id = dcol.id || dcol.accessor;
            var accessorString = dcol.accessor;
            dcol.accessor = function (row) {
              return utils.get(row, accessorString);
            };
            return dcol;
          }

          // Fall back to functional accessor (but require an ID)
          if (dcol.accessor && !dcol.id) {
            console.warn(dcol);
            throw new Error('A column id is required if using a non-string accessor for column above.');
          }

          // Fall back to an undefined accessor
          if (!dcol.accessor) {
            dcol.accessor = function () {
              return undefined;
            };
          }

          return dcol;
        };

        var allDecoratedColumns = [];

        // Decorate the columns
        var decorateAndAddToAll = function decorateAndAddToAll(column, parentColumn) {
          var decoratedColumn = makeDecoratedColumn(column, parentColumn);
          allDecoratedColumns.push(decoratedColumn);
          return decoratedColumn;
        };

        var decoratedColumns = columnsWithExpander.map(function (column) {
          if (column.columns) {
            return methods__extends({}, column, {
              columns: column.columns.map(function (d) {
                return decorateAndAddToAll(d, column);
              })
            });
          }
          return decorateAndAddToAll(column);
        });

        // Build the visible columns, headers and flat column list
        var visibleColumns = decoratedColumns.slice();
        var allVisibleColumns = [];

        visibleColumns = visibleColumns.map(function (column) {
          if (column.columns) {
            var visibleSubColumns = column.columns.filter(function (d) {
              return pivotBy.indexOf(d.id) > -1 ? false : utils.getFirstDefined(d.show, true);
            });
            return methods__extends({}, column, {
              columns: visibleSubColumns
            });
          }
          return column;
        });

        visibleColumns = visibleColumns.filter(function (column) {
          return column.columns ? column.columns.length : pivotBy.indexOf(column.id) > -1 ? false : utils.getFirstDefined(column.show, true);
        });

        // Find any custom pivot location
        var pivotIndex = visibleColumns.findIndex(function (col) {
          return col.pivot;
        });

        // Handle Pivot Columns
        if (pivotBy.length) {
          // Retrieve the pivot columns in the correct pivot order
          var pivotColumns = [];
          pivotBy.forEach(function (pivotID) {
            var found = allDecoratedColumns.find(function (d) {
              return d.id === pivotID;
            });
            if (found) {
              pivotColumns.push(found);
            }
          });

          var PivotParentColumn = pivotColumns.reduce(function (prev, current) {
            return prev && prev === current.parentColumn && current.parentColumn;
          }, pivotColumns[0].parentColumn);

          var PivotGroupHeader = hasHeaderGroups && PivotParentColumn.Header;
          PivotGroupHeader = PivotGroupHeader || function () {
            return preact_compat_es.createElement('strong', null, 'Pivoted');
          };

          var pivotColumnGroup = {
            Header: PivotGroupHeader,
            columns: pivotColumns.map(function (col) {
              return methods__extends({}, _this2.props.pivotDefaults, col, {
                pivoted: true
              });
            })

            // Place the pivotColumns back into the visibleColumns
          };if (pivotIndex >= 0) {
            pivotColumnGroup = methods__extends({}, visibleColumns[pivotIndex], pivotColumnGroup);
            visibleColumns.splice(pivotIndex, 1, pivotColumnGroup);
          } else {
            visibleColumns.unshift(pivotColumnGroup);
          }
        }

        // Build Header Groups
        var headerGroups = [];
        var currentSpan = [];

        // A convenience function to add a header and reset the currentSpan
        var addHeader = function addHeader(columns, column) {
          headerGroups.push(methods__extends({}, _this2.props.column, column, {
            columns: columns
          }));
          currentSpan = [];
        };

        // Build flast list of allVisibleColumns and HeaderGroups
        visibleColumns.forEach(function (column) {
          if (column.columns) {
            allVisibleColumns = allVisibleColumns.concat(column.columns);
            if (currentSpan.length > 0) {
              addHeader(currentSpan);
            }
            addHeader(column.columns, column);
            return;
          }
          allVisibleColumns.push(column);
          currentSpan.push(column);
        });
        if (hasHeaderGroups && currentSpan.length > 0) {
          addHeader(currentSpan);
        }

        // Access the data
        var accessRow = function accessRow(d, i) {
          var _row;

          var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

          var row = (_row = {}, _defineProperty(_row, originalKey, d), _defineProperty(_row, indexKey, i), _defineProperty(_row, subRowsKey, d[subRowsKey]), _defineProperty(_row, nestingLevelKey, level), _row);
          allDecoratedColumns.forEach(function (column) {
            if (column.expander) return;
            row[column.id] = column.accessor(d);
          });
          if (row[subRowsKey]) {
            row[subRowsKey] = row[subRowsKey].map(function (d, i) {
              return accessRow(d, i, level + 1);
            });
          }
          return row;
        };

        // // If the data hasn't changed, just use the cached data
        var resolvedData = this.resolvedData;
        // If the data has changed, run the data resolver and cache the result
        if (!this.resolvedData || dataChanged) {
          resolvedData = resolveData(data);
          this.resolvedData = resolvedData;
        }
        // Use the resolved data
        resolvedData = resolvedData.map(function (d, i) {
          return accessRow(d, i);
        });

        // TODO: Make it possible to fabricate nested rows without pivoting
        var aggregatingColumns = allVisibleColumns.filter(function (d) {
          return !d.expander && d.aggregate;
        });

        // If pivoting, recursively group the data
        var aggregate = function aggregate(rows) {
          var aggregationValues = {};
          aggregatingColumns.forEach(function (column) {
            var values = rows.map(function (d) {
              return d[column.id];
            });
            aggregationValues[column.id] = column.aggregate(values, rows);
          });
          return aggregationValues;
        };
        if (pivotBy.length) {
          var groupRecursively = function groupRecursively(rows, keys) {
            var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

            // This is the last level, just return the rows
            if (i === keys.length) {
              return rows;
            }
            // Group the rows together for this level
            var groupedRows = Object.entries(utils.groupBy(rows, keys[i])).map(function (_ref) {
              var _ref3;

              var _ref2 = _slicedToArray(_ref, 2),
                  key = _ref2[0],
                  value = _ref2[1];

              return _ref3 = {}, _defineProperty(_ref3, pivotIDKey, keys[i]), _defineProperty(_ref3, pivotValKey, key), _defineProperty(_ref3, keys[i], key), _defineProperty(_ref3, subRowsKey, value), _defineProperty(_ref3, nestingLevelKey, i), _defineProperty(_ref3, groupedByPivotKey, true), _ref3;
            });
            // Recurse into the subRows
            groupedRows = groupedRows.map(function (rowGroup) {
              var _extends2;

              var subRows = groupRecursively(rowGroup[subRowsKey], keys, i + 1);
              return methods__extends({}, rowGroup, (_extends2 = {}, _defineProperty(_extends2, subRowsKey, subRows), _defineProperty(_extends2, aggregatedKey, true), _extends2), aggregate(subRows));
            });
            return groupedRows;
          };
          resolvedData = groupRecursively(resolvedData, pivotBy);
        }

        return methods__extends({}, newState, {
          resolvedData: resolvedData,
          allVisibleColumns: allVisibleColumns,
          headerGroups: headerGroups,
          allDecoratedColumns: allDecoratedColumns,
          hasHeaderGroups: hasHeaderGroups
        });
      }
    }, {
      key: 'getSortedData',
      value: function getSortedData(resolvedState) {
        var manual = resolvedState.manual,
            sorted = resolvedState.sorted,
            filtered = resolvedState.filtered,
            defaultFilterMethod = resolvedState.defaultFilterMethod,
            resolvedData = resolvedState.resolvedData,
            allVisibleColumns = resolvedState.allVisibleColumns,
            allDecoratedColumns = resolvedState.allDecoratedColumns;

        var sortMethodsByColumnID = {};

        allDecoratedColumns.filter(function (col) {
          return col.sortMethod;
        }).forEach(function (col) {
          sortMethodsByColumnID[col.id] = col.sortMethod;
        });

        // Resolve the data from either manual data or sorted data
        return {
          sortedData: manual ? resolvedData : this.sortData(this.filterData(resolvedData, filtered, defaultFilterMethod, allVisibleColumns), sorted, sortMethodsByColumnID)
        };
      }
    }, {
      key: 'fireFetchData',
      value: function fireFetchData() {
        this.props.onFetchData(this.getResolvedState(), this);
      }
    }, {
      key: 'getPropOrState',
      value: function getPropOrState(key) {
        return utils.getFirstDefined(this.props[key], this.state[key]);
      }
    }, {
      key: 'getStateOrProp',
      value: function getStateOrProp(key) {
        return utils.getFirstDefined(this.state[key], this.props[key]);
      }
    }, {
      key: 'filterData',
      value: function filterData(data, filtered, defaultFilterMethod, allVisibleColumns) {
        var _this3 = this;

        var filteredData = data;

        if (filtered.length) {
          filteredData = filtered.reduce(function (filteredSoFar, nextFilter) {
            var column = allVisibleColumns.find(function (x) {
              return x.id === nextFilter.id;
            });

            // Don't filter hidden columns or columns that have had their filters disabled
            if (!column || column.filterable === false) {
              return filteredSoFar;
            }

            var filterMethod = column.filterMethod || defaultFilterMethod;

            // If 'filterAll' is set to true, pass the entire dataset to the filter method
            if (column.filterAll) {
              return filterMethod(nextFilter, filteredSoFar, column);
            }
            return filteredSoFar.filter(function (row) {
              return filterMethod(nextFilter, row, column);
            });
          }, filteredData);

          // Apply the filter to the subrows if we are pivoting, and then
          // filter any rows without subcolumns because it would be strange to show
          filteredData = filteredData.map(function (row) {
            if (!row[_this3.props.subRowsKey]) {
              return row;
            }
            return methods__extends({}, row, _defineProperty({}, _this3.props.subRowsKey, _this3.filterData(row[_this3.props.subRowsKey], filtered, defaultFilterMethod, allVisibleColumns)));
          }).filter(function (row) {
            if (!row[_this3.props.subRowsKey]) {
              return true;
            }
            return row[_this3.props.subRowsKey].length > 0;
          });
        }

        return filteredData;
      }
    }, {
      key: 'sortData',
      value: function sortData(data, sorted) {
        var _this4 = this;

        var sortMethodsByColumnID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        if (!sorted.length) {
          return data;
        }

        var sortedData = (this.props.orderByMethod || utils.orderBy)(data, sorted.map(function (sort) {
          // Support custom sorting methods for each column
          if (sortMethodsByColumnID[sort.id]) {
            return function (a, b) {
              return sortMethodsByColumnID[sort.id](a[sort.id], b[sort.id], sort.desc);
            };
          }
          return function (a, b) {
            return _this4.props.defaultSortMethod(a[sort.id], b[sort.id], sort.desc);
          };
        }), sorted.map(function (d) {
          return !d.desc;
        }), this.props.indexKey);

        sortedData.forEach(function (row) {
          if (!row[_this4.props.subRowsKey]) {
            return;
          }
          row[_this4.props.subRowsKey] = _this4.sortData(row[_this4.props.subRowsKey], sorted, sortMethodsByColumnID);
        });

        return sortedData;
      }
    }, {
      key: 'getMinRows',
      value: function getMinRows() {
        return utils.getFirstDefined(this.props.minRows, this.getStateOrProp('pageSize'));
      }

      // User actions

    }, {
      key: 'onPageChange',
      value: function onPageChange(page) {
        var _props = this.props,
            onPageChange = _props.onPageChange,
            collapseOnPageChange = _props.collapseOnPageChange;

        var newState = { page: page };
        if (collapseOnPageChange) {
          newState.expanded = {};
        }
        this.setStateWithData(newState, function () {
          return onPageChange && onPageChange(page);
        });
      }
    }, {
      key: 'onPageSizeChange',
      value: function onPageSizeChange(newPageSize) {
        var onPageSizeChange = this.props.onPageSizeChange;

        var _getResolvedState = this.getResolvedState(),
            pageSize = _getResolvedState.pageSize,
            page = _getResolvedState.page;

        // Normalize the page to display


        var currentRow = pageSize * page;
        var newPage = Math.floor(currentRow / newPageSize);

        this.setStateWithData({
          pageSize: newPageSize,
          page: newPage
        }, function () {
          return onPageSizeChange && onPageSizeChange(newPageSize, newPage);
        });
      }
    }, {
      key: 'sortColumn',
      value: function sortColumn(column, additive) {
        var _getResolvedState2 = this.getResolvedState(),
            sorted = _getResolvedState2.sorted,
            skipNextSort = _getResolvedState2.skipNextSort,
            defaultSortDesc = _getResolvedState2.defaultSortDesc;

        var firstSortDirection = Object.prototype.hasOwnProperty.call(column, 'defaultSortDesc') ? column.defaultSortDesc : defaultSortDesc;
        var secondSortDirection = !firstSortDirection;

        // we can't stop event propagation from the column resize move handlers
        // attached to the document because of react's synthetic events
        // so we have to prevent the sort function from actually sorting
        // if we click on the column resize element within a header.
        if (skipNextSort) {
          this.setStateWithData({
            skipNextSort: false
          });
          return;
        }

        var onSortedChange = this.props.onSortedChange;

        var newSorted = utils.clone(sorted || []).map(function (d) {
          d.desc = utils.isSortingDesc(d);
          return d;
        });
        if (!utils.isArray(column)) {
          // Single-Sort
          var existingIndex = newSorted.findIndex(function (d) {
            return d.id === column.id;
          });
          if (existingIndex > -1) {
            var existing = newSorted[existingIndex];
            if (existing.desc === secondSortDirection) {
              if (additive) {
                newSorted.splice(existingIndex, 1);
              } else {
                existing.desc = firstSortDirection;
                newSorted = [existing];
              }
            } else {
              existing.desc = secondSortDirection;
              if (!additive) {
                newSorted = [existing];
              }
            }
          } else if (additive) {
            newSorted.push({
              id: column.id,
              desc: firstSortDirection
            });
          } else {
            newSorted = [{
              id: column.id,
              desc: firstSortDirection
            }];
          }
        } else {
          // Multi-Sort
          var _existingIndex = newSorted.findIndex(function (d) {
            return d.id === column[0].id;
          });
          // Existing Sorted Column
          if (_existingIndex > -1) {
            var _existing = newSorted[_existingIndex];
            if (_existing.desc === secondSortDirection) {
              if (additive) {
                newSorted.splice(_existingIndex, column.length);
              } else {
                column.forEach(function (d, i) {
                  newSorted[_existingIndex + i].desc = firstSortDirection;
                });
              }
            } else {
              column.forEach(function (d, i) {
                newSorted[_existingIndex + i].desc = secondSortDirection;
              });
            }
            if (!additive) {
              newSorted = newSorted.slice(_existingIndex, column.length);
            }
            // New Sort Column
          } else if (additive) {
            newSorted = newSorted.concat(column.map(function (d) {
              return {
                id: d.id,
                desc: firstSortDirection
              };
            }));
          } else {
            newSorted = column.map(function (d) {
              return {
                id: d.id,
                desc: firstSortDirection
              };
            });
          }
        }

        this.setStateWithData({
          page: !sorted.length && newSorted.length || !additive ? 0 : this.state.page,
          sorted: newSorted
        }, function () {
          return onSortedChange && onSortedChange(newSorted, column, additive);
        });
      }
    }, {
      key: 'filterColumn',
      value: function filterColumn(column, value) {
        var _getResolvedState3 = this.getResolvedState(),
            filtered = _getResolvedState3.filtered;

        var onFilteredChange = this.props.onFilteredChange;

        // Remove old filter first if it exists

        var newFiltering = (filtered || []).filter(function (x) {
          return x.id !== column.id;
        });

        if (value !== '') {
          newFiltering.push({
            id: column.id,
            value: value
          });
        }

        this.setStateWithData({
          filtered: newFiltering
        }, function () {
          return onFilteredChange && onFilteredChange(newFiltering, column, value);
        });
      }
    }, {
      key: 'resizeColumnStart',
      value: function resizeColumnStart(event, column, isTouch) {
        var _this5 = this;

        event.stopPropagation();
        var parentWidth = event.target.parentElement.getBoundingClientRect().width;

        var pageX = void 0;
        if (isTouch) {
          pageX = event.changedTouches[0].pageX;
        } else {
          pageX = event.pageX;
        }

        this.trapEvents = true;
        this.setStateWithData({
          currentlyResizing: {
            id: column.id,
            startX: pageX,
            parentWidth: parentWidth
          }
        }, function () {
          if (isTouch) {
            document.addEventListener('touchmove', _this5.resizeColumnMoving);
            document.addEventListener('touchcancel', _this5.resizeColumnEnd);
            document.addEventListener('touchend', _this5.resizeColumnEnd);
          } else {
            document.addEventListener('mousemove', _this5.resizeColumnMoving);
            document.addEventListener('mouseup', _this5.resizeColumnEnd);
            document.addEventListener('mouseleave', _this5.resizeColumnEnd);
          }
        });
      }
    }, {
      key: 'resizeColumnMoving',
      value: function resizeColumnMoving(event) {
        event.stopPropagation();
        var onResizedChange = this.props.onResizedChange;

        var _getResolvedState4 = this.getResolvedState(),
            resized = _getResolvedState4.resized,
            currentlyResizing = _getResolvedState4.currentlyResizing;

        // Delete old value


        var newResized = resized.filter(function (x) {
          return x.id !== currentlyResizing.id;
        });

        var pageX = void 0;

        if (event.type === 'touchmove') {
          pageX = event.changedTouches[0].pageX;
        } else if (event.type === 'mousemove') {
          pageX = event.pageX;
        }

        // Set the min size to 10 to account for margin and border or else the
        // group headers don't line up correctly
        var newWidth = Math.max(currentlyResizing.parentWidth + pageX - currentlyResizing.startX, 11);

        newResized.push({
          id: currentlyResizing.id,
          value: newWidth
        });

        this.setStateWithData({
          resized: newResized
        }, function () {
          return onResizedChange && onResizedChange(newResized, event);
        });
      }
    }, {
      key: 'resizeColumnEnd',
      value: function resizeColumnEnd(event) {
        event.stopPropagation();
        var isTouch = event.type === 'touchend' || event.type === 'touchcancel';

        if (isTouch) {
          document.removeEventListener('touchmove', this.resizeColumnMoving);
          document.removeEventListener('touchcancel', this.resizeColumnEnd);
          document.removeEventListener('touchend', this.resizeColumnEnd);
        }

        // If its a touch event clear the mouse one's as well because sometimes
        // the mouseDown event gets called as well, but the mouseUp event doesn't
        document.removeEventListener('mousemove', this.resizeColumnMoving);
        document.removeEventListener('mouseup', this.resizeColumnEnd);
        document.removeEventListener('mouseleave', this.resizeColumnEnd);

        // The touch events don't propagate up to the sorting's onMouseDown event so
        // no need to prevent it from happening or else the first click after a touch
        // event resize will not sort the column.
        if (!isTouch) {
          this.setStateWithData({
            skipNextSort: true,
            currentlyResizing: false
          });
        }
      }
    }]);

    return _class;
  }(Base);
});
// CONCATENATED MODULE: ../node_modules/react-table/es/pagination.js
var pagination__createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var pagination__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function pagination__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function pagination__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function pagination__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}



//
// import _ from './utils'

var pagination_defaultButton = function defaultButton(props) {
  return preact_compat_es.createElement('button', pagination__extends({ type: 'button' }, props, { className: '-btn' }), props.children);
};

var pagination_ReactTablePagination = function (_Component) {
  pagination__inherits(ReactTablePagination, _Component);

  function ReactTablePagination(props) {
    pagination__classCallCheck(this, ReactTablePagination);

    var _this = pagination__possibleConstructorReturn(this, (ReactTablePagination.__proto__ || Object.getPrototypeOf(ReactTablePagination)).call(this));

    _this.getSafePage = _this.getSafePage.bind(_this);
    _this.changePage = _this.changePage.bind(_this);
    _this.applyPage = _this.applyPage.bind(_this);

    _this.state = {
      page: props.page
    };
    return _this;
  }

  pagination__createClass(ReactTablePagination, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ page: nextProps.page });
    }
  }, {
    key: 'getSafePage',
    value: function getSafePage(page) {
      if (Number.isNaN(page)) {
        page = this.props.page;
      }
      return Math.min(Math.max(page, 0), this.props.pages - 1);
    }
  }, {
    key: 'changePage',
    value: function changePage(page) {
      page = this.getSafePage(page);
      this.setState({ page: page });
      if (this.props.page !== page) {
        this.props.onPageChange(page);
      }
    }
  }, {
    key: 'applyPage',
    value: function applyPage(e) {
      if (e) {
        e.preventDefault();
      }
      var page = this.state.page;
      this.changePage(page === '' ? this.props.page : page);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          pages = _props.pages,
          page = _props.page,
          showPageSizeOptions = _props.showPageSizeOptions,
          pageSizeOptions = _props.pageSizeOptions,
          pageSize = _props.pageSize,
          showPageJump = _props.showPageJump,
          canPrevious = _props.canPrevious,
          canNext = _props.canNext,
          onPageSizeChange = _props.onPageSizeChange,
          className = _props.className,
          _props$PreviousCompon = _props.PreviousComponent,
          PreviousComponent = _props$PreviousCompon === undefined ? pagination_defaultButton : _props$PreviousCompon,
          _props$NextComponent = _props.NextComponent,
          NextComponent = _props$NextComponent === undefined ? pagination_defaultButton : _props$NextComponent;

      return preact_compat_es.createElement('div', { className: classnames_default()(className, '-pagination'), style: this.props.style }, preact_compat_es.createElement('div', { className: '-previous' }, preact_compat_es.createElement(PreviousComponent, {
        onClick: function onClick() {
          if (!canPrevious) return;
          _this2.changePage(page - 1);
        },
        disabled: !canPrevious
      }, this.props.previousText)), preact_compat_es.createElement('div', { className: '-center' }, preact_compat_es.createElement('span', { className: '-pageInfo' }, this.props.pageText, ' ', showPageJump ? preact_compat_es.createElement('div', { className: '-pageJump' }, preact_compat_es.createElement('input', {
        type: this.state.page === '' ? 'text' : 'number',
        onChange: function onChange(e) {
          var val = e.target.value;
          var page = val - 1;
          if (val === '') {
            return _this2.setState({ page: val });
          }
          _this2.setState({ page: _this2.getSafePage(page) });
        },
        value: this.state.page === '' ? '' : this.state.page + 1,
        onBlur: this.applyPage,
        onKeyPress: function onKeyPress(e) {
          if (e.which === 13 || e.keyCode === 13) {
            _this2.applyPage();
          }
        }
      })) : preact_compat_es.createElement('span', { className: '-currentPage' }, page + 1), ' ', this.props.ofText, ' ', preact_compat_es.createElement('span', { className: '-totalPages' }, pages || 1)), showPageSizeOptions && preact_compat_es.createElement('span', { className: 'select-wrap -pageSizeOptions' }, preact_compat_es.createElement('select', { onChange: function onChange(e) {
          return onPageSizeChange(Number(e.target.value));
        }, value: pageSize }, pageSizeOptions.map(function (option, i) {
        return (
          // eslint-disable-next-line react/no-array-index-key
          preact_compat_es.createElement('option', { key: i, value: option }, option, ' ', _this2.props.rowsText)
        );
      })))), preact_compat_es.createElement('div', { className: '-next' }, preact_compat_es.createElement(NextComponent, {
        onClick: function onClick() {
          if (!canNext) return;
          _this2.changePage(page + 1);
        },
        disabled: !canNext
      }, this.props.nextText)));
    }
  }]);

  return ReactTablePagination;
}(Component$1);

/* harmony default export */ var es_pagination = (pagination_ReactTablePagination);
// CONCATENATED MODULE: ../node_modules/react-table/es/defaultProps.js
var defaultProps__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function defaultProps__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}



//



var emptyObj = function emptyObj() {
  return {};
};

/* harmony default export */ var defaultProps = ({
  // General
  data: [],
  resolveData: function resolveData(data) {
    return data;
  },
  loading: false,
  showPagination: true,
  showPaginationTop: false,
  showPaginationBottom: true,
  showPageSizeOptions: true,
  pageSizeOptions: [5, 10, 20, 25, 50, 100],
  defaultPageSize: 20,
  showPageJump: true,
  collapseOnSortingChange: true,
  collapseOnPageChange: true,
  collapseOnDataChange: true,
  freezeWhenExpanded: false,
  sortable: true,
  multiSort: true,
  resizable: true,
  filterable: false,
  defaultSortDesc: false,
  defaultSorted: [],
  defaultFiltered: [],
  defaultResized: [],
  defaultExpanded: {},
  // eslint-disable-next-line no-unused-vars
  defaultFilterMethod: function defaultFilterMethod(filter, row, column) {
    var id = filter.pivotId || filter.id;
    return row[id] !== undefined ? String(row[id]).startsWith(filter.value) : true;
  },
  // eslint-disable-next-line no-unused-vars
  defaultSortMethod: function defaultSortMethod(a, b, desc) {
    // force null and undefined to the bottom
    a = a === null || a === undefined ? '' : a;
    b = b === null || b === undefined ? '' : b;
    // force any string values to lowercase
    a = typeof a === 'string' ? a.toLowerCase() : a;
    b = typeof b === 'string' ? b.toLowerCase() : b;
    // Return either 1 or -1 to indicate a sort priority
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }
    // returning 0, undefined or any falsey value will use subsequent sorts or
    // the index as a tiebreaker
    return 0;
  },

  // Controlled State Props
  // page: undefined,
  // pageSize: undefined,
  // sorted: [],
  // filtered: [],
  // resized: [],
  // expanded: {},

  // Controlled State Callbacks
  onPageChange: undefined,
  onPageSizeChange: undefined,
  onSortedChange: undefined,
  onFilteredChange: undefined,
  onResizedChange: undefined,
  onExpandedChange: undefined,

  // Pivoting
  pivotBy: undefined,

  // Key Constants
  pivotValKey: '_pivotVal',
  pivotIDKey: '_pivotID',
  subRowsKey: '_subRows',
  aggregatedKey: '_aggregated',
  nestingLevelKey: '_nestingLevel',
  originalKey: '_original',
  indexKey: '_index',
  groupedByPivotKey: '_groupedByPivot',

  // Server-side Callbacks
  onFetchData: function onFetchData() {
    return null;
  },

  // Classes
  className: '',
  style: {},

  // Component decorators
  getProps: emptyObj,
  getTableProps: emptyObj,
  getTheadGroupProps: emptyObj,
  getTheadGroupTrProps: emptyObj,
  getTheadGroupThProps: emptyObj,
  getTheadProps: emptyObj,
  getTheadTrProps: emptyObj,
  getTheadThProps: emptyObj,
  getTheadFilterProps: emptyObj,
  getTheadFilterTrProps: emptyObj,
  getTheadFilterThProps: emptyObj,
  getTbodyProps: emptyObj,
  getTrGroupProps: emptyObj,
  getTrProps: emptyObj,
  getTdProps: emptyObj,
  getTfootProps: emptyObj,
  getTfootTrProps: emptyObj,
  getTfootTdProps: emptyObj,
  getPaginationProps: emptyObj,
  getLoadingProps: emptyObj,
  getNoDataProps: emptyObj,
  getResizerProps: emptyObj,

  // Global Column Defaults
  column: {
    // Renderers
    Cell: undefined,
    Header: undefined,
    Footer: undefined,
    Aggregated: undefined,
    Pivot: undefined,
    PivotValue: undefined,
    Expander: undefined,
    Filter: undefined,
    // All Columns
    sortable: undefined, // use table default
    resizable: undefined, // use table default
    filterable: undefined, // use table default
    show: true,
    minWidth: 100,
    // Cells only
    className: '',
    style: {},
    getProps: emptyObj,
    // Pivot only
    aggregate: undefined,
    // Headers only
    headerClassName: '',
    headerStyle: {},
    getHeaderProps: emptyObj,
    // Footers only
    footerClassName: '',
    footerStyle: {},
    getFooterProps: emptyObj,
    filterMethod: undefined,
    filterAll: false,
    sortMethod: undefined
  },

  // Global Expander Column Defaults
  expanderDefaults: {
    sortable: false,
    resizable: false,
    filterable: false,
    width: 35
  },

  pivotDefaults: {
    // extend the defaults for pivoted columns here
  },

  // Text
  previousText: 'Previous',
  nextText: 'Next',
  loadingText: 'Loading...',
  noDataText: 'No rows found',
  pageText: 'Page',
  ofText: 'of',
  rowsText: 'rows',

  // Components
  TableComponent: function TableComponent(_ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = defaultProps__objectWithoutProperties(_ref, ['children', 'className']);

    return preact_compat_es.createElement('div', defaultProps__extends({
      className: classnames_default()('rt-table', className),
      role: 'grid'
      // tabIndex='0'
    }, rest), children);
  },
  TheadComponent: utils.makeTemplateComponent('rt-thead', 'Thead'),
  TbodyComponent: utils.makeTemplateComponent('rt-tbody', 'Tbody'),
  TrGroupComponent: function TrGroupComponent(_ref2) {
    var children = _ref2.children,
        className = _ref2.className,
        rest = defaultProps__objectWithoutProperties(_ref2, ['children', 'className']);

    return preact_compat_es.createElement('div', defaultProps__extends({ className: classnames_default()('rt-tr-group', className), role: 'rowgroup' }, rest), children);
  },
  TrComponent: function TrComponent(_ref3) {
    var children = _ref3.children,
        className = _ref3.className,
        rest = defaultProps__objectWithoutProperties(_ref3, ['children', 'className']);

    return preact_compat_es.createElement('div', defaultProps__extends({ className: classnames_default()('rt-tr', className), role: 'row' }, rest), children);
  },
  ThComponent: function ThComponent(_ref4) {
    var toggleSort = _ref4.toggleSort,
        className = _ref4.className,
        children = _ref4.children,
        rest = defaultProps__objectWithoutProperties(_ref4, ['toggleSort', 'className', 'children']);

    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      preact_compat_es.createElement('div', defaultProps__extends({
        className: classnames_default()('rt-th', className),
        onClick: function onClick(e) {
          return toggleSort && toggleSort(e);
        },
        role: 'columnheader',
        tabIndex: '-1' // Resolves eslint issues without implementing keyboard navigation incorrectly
      }, rest), children)
    );
  },
  TdComponent: function TdComponent(_ref5) {
    var toggleSort = _ref5.toggleSort,
        className = _ref5.className,
        children = _ref5.children,
        rest = defaultProps__objectWithoutProperties(_ref5, ['toggleSort', 'className', 'children']);

    return preact_compat_es.createElement('div', defaultProps__extends({ className: classnames_default()('rt-td', className), role: 'gridcell' }, rest), children);
  },
  TfootComponent: utils.makeTemplateComponent('rt-tfoot', 'Tfoot'),
  FilterComponent: function FilterComponent(_ref6) {
    var filter = _ref6.filter,
        _onChange = _ref6.onChange;
    return preact_compat_es.createElement('input', {
      type: 'text',
      style: {
        width: '100%'
      },
      value: filter ? filter.value : '',
      onChange: function onChange(event) {
        return _onChange(event.target.value);
      }
    });
  },
  ExpanderComponent: function ExpanderComponent(_ref7) {
    var isExpanded = _ref7.isExpanded;
    return preact_compat_es.createElement('div', { className: classnames_default()('rt-expander', isExpanded && '-open') }, '\u2022');
  },
  PivotValueComponent: function PivotValueComponent(_ref8) {
    var subRows = _ref8.subRows,
        value = _ref8.value;
    return preact_compat_es.createElement('span', null, value, ' ', subRows && '(' + subRows.length + ')');
  },
  AggregatedComponent: function AggregatedComponent(_ref9) {
    var subRows = _ref9.subRows,
        column = _ref9.column;

    var previewValues = subRows.filter(function (d) {
      return typeof d[column.id] !== 'undefined';
    }).map(function (row, i) {
      return (
        // eslint-disable-next-line react/no-array-index-key
        preact_compat_es.createElement('span', { key: i }, row[column.id], i < subRows.length - 1 ? ', ' : '')
      );
    });
    return preact_compat_es.createElement('span', null, previewValues);
  },
  PivotComponent: undefined, // this is a computed default generated using
  // the ExpanderComponent and PivotValueComponent at run-time in methods.js
  PaginationComponent: es_pagination,
  PreviousComponent: undefined,
  NextComponent: undefined,
  LoadingComponent: function LoadingComponent(_ref10) {
    var className = _ref10.className,
        loading = _ref10.loading,
        loadingText = _ref10.loadingText,
        rest = defaultProps__objectWithoutProperties(_ref10, ['className', 'loading', 'loadingText']);

    return preact_compat_es.createElement('div', defaultProps__extends({ className: classnames_default()('-loading', { '-active': loading }, className) }, rest), preact_compat_es.createElement('div', { className: '-loading-inner' }, loadingText));
  },
  NoDataComponent: utils.makeTemplateComponent('rt-noData', 'NoData'),
  ResizerComponent: utils.makeTemplateComponent('rt-resizer', 'Resizer'),
  PadRowComponent: function PadRowComponent() {
    return preact_compat_es.createElement('span', null, '\xA0');
  }
});
// CONCATENATED MODULE: ../node_modules/react-table/es/propTypes.js


/* harmony default export */ var es_propTypes = ({
  // General
  data: prop_types_default.a.any,
  loading: prop_types_default.a.bool,
  showPagination: prop_types_default.a.bool,
  showPaginationTop: prop_types_default.a.bool,
  showPaginationBottom: prop_types_default.a.bool,
  showPageSizeOptions: prop_types_default.a.bool,
  pageSizeOptions: prop_types_default.a.array,
  defaultPageSize: prop_types_default.a.number,
  showPageJump: prop_types_default.a.bool,
  collapseOnSortingChange: prop_types_default.a.bool,
  collapseOnPageChange: prop_types_default.a.bool,
  collapseOnDataChange: prop_types_default.a.bool,
  freezeWhenExpanded: prop_types_default.a.bool,
  sortable: prop_types_default.a.bool,
  resizable: prop_types_default.a.bool,
  filterable: prop_types_default.a.bool,
  defaultSortDesc: prop_types_default.a.bool,
  defaultSorted: prop_types_default.a.array,
  defaultFiltered: prop_types_default.a.array,
  defaultResized: prop_types_default.a.array,
  defaultExpanded: prop_types_default.a.object,
  defaultFilterMethod: prop_types_default.a.func,
  defaultSortMethod: prop_types_default.a.func,

  // Controlled State Callbacks
  onPageChange: prop_types_default.a.func,
  onPageSizeChange: prop_types_default.a.func,
  onSortedChange: prop_types_default.a.func,
  onFilteredChange: prop_types_default.a.func,
  onResizedChange: prop_types_default.a.func,
  onExpandedChange: prop_types_default.a.func,

  // Pivoting
  pivotBy: prop_types_default.a.array,

  // Key Constants
  pivotValKey: prop_types_default.a.string,
  pivotIDKey: prop_types_default.a.string,
  subRowsKey: prop_types_default.a.string,
  aggregatedKey: prop_types_default.a.string,
  nestingLevelKey: prop_types_default.a.string,
  originalKey: prop_types_default.a.string,
  indexKey: prop_types_default.a.string,
  groupedByPivotKey: prop_types_default.a.string,

  // Server-side Callbacks
  onFetchData: prop_types_default.a.func,

  // Classes
  className: prop_types_default.a.string,
  style: prop_types_default.a.object,

  // Component decorators
  getProps: prop_types_default.a.func,
  getTableProps: prop_types_default.a.func,
  getTheadGroupProps: prop_types_default.a.func,
  getTheadGroupTrProps: prop_types_default.a.func,
  getTheadGroupThProps: prop_types_default.a.func,
  getTheadProps: prop_types_default.a.func,
  getTheadTrProps: prop_types_default.a.func,
  getTheadThProps: prop_types_default.a.func,
  getTheadFilterProps: prop_types_default.a.func,
  getTheadFilterTrProps: prop_types_default.a.func,
  getTheadFilterThProps: prop_types_default.a.func,
  getTbodyProps: prop_types_default.a.func,
  getTrGroupProps: prop_types_default.a.func,
  getTrProps: prop_types_default.a.func,
  getTdProps: prop_types_default.a.func,
  getTfootProps: prop_types_default.a.func,
  getTfootTrProps: prop_types_default.a.func,
  getTfootTdProps: prop_types_default.a.func,
  getPaginationProps: prop_types_default.a.func,
  getLoadingProps: prop_types_default.a.func,
  getNoDataProps: prop_types_default.a.func,
  getResizerProps: prop_types_default.a.func,

  // Global Column Defaults
  columns: prop_types_default.a.arrayOf(prop_types_default.a.shape({
    // Renderers
    Cell: prop_types_default.a.oneOfType([prop_types_default.a.element, prop_types_default.a.string, prop_types_default.a.func]),
    Header: prop_types_default.a.oneOfType([prop_types_default.a.element, prop_types_default.a.string, prop_types_default.a.func]),
    Footer: prop_types_default.a.oneOfType([prop_types_default.a.element, prop_types_default.a.string, prop_types_default.a.func]),
    Aggregated: prop_types_default.a.oneOfType([prop_types_default.a.element, prop_types_default.a.string, prop_types_default.a.func]),
    Pivot: prop_types_default.a.oneOfType([prop_types_default.a.element, prop_types_default.a.string, prop_types_default.a.func]),
    PivotValue: prop_types_default.a.oneOfType([prop_types_default.a.element, prop_types_default.a.string, prop_types_default.a.func]),
    Expander: prop_types_default.a.oneOfType([prop_types_default.a.element, prop_types_default.a.string, prop_types_default.a.func]),
    Filter: prop_types_default.a.oneOfType([prop_types_default.a.element, prop_types_default.a.func]),

    // All Columns
    sortable: prop_types_default.a.bool, // use table default
    resizable: prop_types_default.a.bool, // use table default
    filterable: prop_types_default.a.bool, // use table default
    show: prop_types_default.a.bool,
    minWidth: prop_types_default.a.number,

    // Cells only
    className: prop_types_default.a.string,
    style: prop_types_default.a.object,
    getProps: prop_types_default.a.func,

    // Pivot only
    aggregate: prop_types_default.a.func,

    // Headers only
    headerClassName: prop_types_default.a.string,
    headerStyle: prop_types_default.a.object,
    getHeaderProps: prop_types_default.a.func,

    // Footers only
    footerClassName: prop_types_default.a.string,
    footerStyle: prop_types_default.a.object,
    getFooterProps: prop_types_default.a.object,
    filterMethod: prop_types_default.a.func,
    filterAll: prop_types_default.a.bool,
    sortMethod: prop_types_default.a.func
  })),

  // Global Expander Column Defaults
  expanderDefaults: prop_types_default.a.shape({
    sortable: prop_types_default.a.bool,
    resizable: prop_types_default.a.bool,
    filterable: prop_types_default.a.bool,
    width: prop_types_default.a.number
  }),

  pivotDefaults: prop_types_default.a.object,

  // Text
  previousText: prop_types_default.a.node,
  nextText: prop_types_default.a.node,
  loadingText: prop_types_default.a.node,
  noDataText: prop_types_default.a.node,
  pageText: prop_types_default.a.node,
  ofText: prop_types_default.a.node,
  rowsText: prop_types_default.a.node,

  // Components
  TableComponent: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.element]),
  TheadComponent: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.element]),
  TbodyComponent: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.element]),
  TrGroupComponent: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.element]),
  TrComponent: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.element]),
  ThComponent: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.element]),
  TdComponent: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.element]),
  TfootComponent: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.element]),
  FilterComponent: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.element]),
  ExpanderComponent: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.element]),
  PivotValueComponent: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.element]),
  AggregatedComponent: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.element]),
  // this is a computed default generated using
  PivotComponent: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.element]),
  // the ExpanderComponent and PivotValueComponent at run-time in methods.js
  PaginationComponent: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.element]),
  PreviousComponent: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.element]),
  NextComponent: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.element]),
  LoadingComponent: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.element]),
  NoDataComponent: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.element]),
  ResizerComponent: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.element]),
  PadRowComponent: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.element])
});
// CONCATENATED MODULE: ../node_modules/react-table/es/index.js
var es__slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var es__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var es__createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function es__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function es__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function es__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}



//






var ReactTableDefaults = defaultProps;

var es_ReactTable = function (_Methods) {
  es__inherits(ReactTable, _Methods);

  function ReactTable(props) {
    es__classCallCheck(this, ReactTable);

    var _this = es__possibleConstructorReturn(this, (ReactTable.__proto__ || Object.getPrototypeOf(ReactTable)).call(this));

    _this.getResolvedState = _this.getResolvedState.bind(_this);
    _this.getDataModel = _this.getDataModel.bind(_this);
    _this.getSortedData = _this.getSortedData.bind(_this);
    _this.fireFetchData = _this.fireFetchData.bind(_this);
    _this.getPropOrState = _this.getPropOrState.bind(_this);
    _this.getStateOrProp = _this.getStateOrProp.bind(_this);
    _this.filterData = _this.filterData.bind(_this);
    _this.sortData = _this.sortData.bind(_this);
    _this.getMinRows = _this.getMinRows.bind(_this);
    _this.onPageChange = _this.onPageChange.bind(_this);
    _this.onPageSizeChange = _this.onPageSizeChange.bind(_this);
    _this.sortColumn = _this.sortColumn.bind(_this);
    _this.filterColumn = _this.filterColumn.bind(_this);
    _this.resizeColumnStart = _this.resizeColumnStart.bind(_this);
    _this.resizeColumnEnd = _this.resizeColumnEnd.bind(_this);
    _this.resizeColumnMoving = _this.resizeColumnMoving.bind(_this);

    _this.state = {
      page: 0,
      pageSize: props.defaultPageSize,
      sorted: props.defaultSorted,
      expanded: props.defaultExpanded,
      filtered: props.defaultFiltered,
      resized: props.defaultResized,
      currentlyResizing: false,
      skipNextSort: false
    };
    return _this;
  }

  es__createClass(ReactTable, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var resolvedState = this.getResolvedState();
      var children = resolvedState.children,
          className = resolvedState.className,
          style = resolvedState.style,
          getProps = resolvedState.getProps,
          getTableProps = resolvedState.getTableProps,
          getTheadGroupProps = resolvedState.getTheadGroupProps,
          getTheadGroupTrProps = resolvedState.getTheadGroupTrProps,
          getTheadGroupThProps = resolvedState.getTheadGroupThProps,
          getTheadProps = resolvedState.getTheadProps,
          getTheadTrProps = resolvedState.getTheadTrProps,
          getTheadThProps = resolvedState.getTheadThProps,
          getTheadFilterProps = resolvedState.getTheadFilterProps,
          getTheadFilterTrProps = resolvedState.getTheadFilterTrProps,
          getTheadFilterThProps = resolvedState.getTheadFilterThProps,
          getTbodyProps = resolvedState.getTbodyProps,
          getTrGroupProps = resolvedState.getTrGroupProps,
          getTrProps = resolvedState.getTrProps,
          getTdProps = resolvedState.getTdProps,
          getTfootProps = resolvedState.getTfootProps,
          getTfootTrProps = resolvedState.getTfootTrProps,
          getTfootTdProps = resolvedState.getTfootTdProps,
          getPaginationProps = resolvedState.getPaginationProps,
          getLoadingProps = resolvedState.getLoadingProps,
          getNoDataProps = resolvedState.getNoDataProps,
          getResizerProps = resolvedState.getResizerProps,
          showPagination = resolvedState.showPagination,
          showPaginationTop = resolvedState.showPaginationTop,
          showPaginationBottom = resolvedState.showPaginationBottom,
          manual = resolvedState.manual,
          loadingText = resolvedState.loadingText,
          noDataText = resolvedState.noDataText,
          sortable = resolvedState.sortable,
          multiSort = resolvedState.multiSort,
          resizable = resolvedState.resizable,
          filterable = resolvedState.filterable,
          pivotIDKey = resolvedState.pivotIDKey,
          pivotValKey = resolvedState.pivotValKey,
          pivotBy = resolvedState.pivotBy,
          subRowsKey = resolvedState.subRowsKey,
          aggregatedKey = resolvedState.aggregatedKey,
          originalKey = resolvedState.originalKey,
          indexKey = resolvedState.indexKey,
          groupedByPivotKey = resolvedState.groupedByPivotKey,
          loading = resolvedState.loading,
          pageSize = resolvedState.pageSize,
          page = resolvedState.page,
          sorted = resolvedState.sorted,
          filtered = resolvedState.filtered,
          resized = resolvedState.resized,
          expanded = resolvedState.expanded,
          pages = resolvedState.pages,
          onExpandedChange = resolvedState.onExpandedChange,
          TableComponent = resolvedState.TableComponent,
          TheadComponent = resolvedState.TheadComponent,
          TbodyComponent = resolvedState.TbodyComponent,
          TrGroupComponent = resolvedState.TrGroupComponent,
          TrComponent = resolvedState.TrComponent,
          ThComponent = resolvedState.ThComponent,
          TdComponent = resolvedState.TdComponent,
          TfootComponent = resolvedState.TfootComponent,
          PaginationComponent = resolvedState.PaginationComponent,
          LoadingComponent = resolvedState.LoadingComponent,
          SubComponent = resolvedState.SubComponent,
          NoDataComponent = resolvedState.NoDataComponent,
          ResizerComponent = resolvedState.ResizerComponent,
          ExpanderComponent = resolvedState.ExpanderComponent,
          PivotValueComponent = resolvedState.PivotValueComponent,
          PivotComponent = resolvedState.PivotComponent,
          AggregatedComponent = resolvedState.AggregatedComponent,
          FilterComponent = resolvedState.FilterComponent,
          PadRowComponent = resolvedState.PadRowComponent,
          resolvedData = resolvedState.resolvedData,
          allVisibleColumns = resolvedState.allVisibleColumns,
          headerGroups = resolvedState.headerGroups,
          hasHeaderGroups = resolvedState.hasHeaderGroups,
          sortedData = resolvedState.sortedData,
          currentlyResizing = resolvedState.currentlyResizing;

      // Pagination

      var startRow = pageSize * page;
      var endRow = startRow + pageSize;
      var pageRows = manual ? resolvedData : sortedData.slice(startRow, endRow);
      var minRows = this.getMinRows();
      var padRows = utils.range(Math.max(minRows - pageRows.length, 0));

      var hasColumnFooter = allVisibleColumns.some(function (d) {
        return d.Footer;
      });
      var hasFilters = filterable || allVisibleColumns.some(function (d) {
        return d.filterable;
      });

      var recurseRowsViewIndex = function recurseRowsViewIndex(rows) {
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
        return [rows.map(function (row, i) {
          index += 1;
          var rowWithViewIndex = es__extends({}, row, {
            _viewIndex: index
          });
          var newPath = path.concat([i]);
          if (rowWithViewIndex[subRowsKey] && utils.get(expanded, newPath)) {
            var _recurseRowsViewIndex = recurseRowsViewIndex(rowWithViewIndex[subRowsKey], newPath, index);

            var _recurseRowsViewIndex2 = es__slicedToArray(_recurseRowsViewIndex, 2);

            rowWithViewIndex[subRowsKey] = _recurseRowsViewIndex2[0];
            index = _recurseRowsViewIndex2[1];
          }
          return rowWithViewIndex;
        }), index];
      };

      var _recurseRowsViewIndex3 = recurseRowsViewIndex(pageRows);

      var _recurseRowsViewIndex4 = es__slicedToArray(_recurseRowsViewIndex3, 1);

      pageRows = _recurseRowsViewIndex4[0];

      var canPrevious = page > 0;
      var canNext = page + 1 < pages;

      var rowMinWidth = utils.sum(allVisibleColumns.map(function (d) {
        var resizedColumn = resized.find(function (x) {
          return x.id === d.id;
        }) || {};
        return utils.getFirstDefined(resizedColumn.value, d.width, d.minWidth);
      }));

      var rowIndex = -1;

      var finalState = es__extends({}, resolvedState, {
        startRow: startRow,
        endRow: endRow,
        pageRows: pageRows,
        minRows: minRows,
        padRows: padRows,
        hasColumnFooter: hasColumnFooter,
        canPrevious: canPrevious,
        canNext: canNext,
        rowMinWidth: rowMinWidth
      });

      var rootProps = utils.splitProps(getProps(finalState, undefined, undefined, this));
      var tableProps = utils.splitProps(getTableProps(finalState, undefined, undefined, this));
      var tBodyProps = utils.splitProps(getTbodyProps(finalState, undefined, undefined, this));
      var loadingProps = getLoadingProps(finalState, undefined, undefined, this);
      var noDataProps = getNoDataProps(finalState, undefined, undefined, this);

      // Visual Components

      var makeHeaderGroup = function makeHeaderGroup(column, i) {
        var resizedValue = function resizedValue(col) {
          return (resized.find(function (x) {
            return x.id === col.id;
          }) || {}).value;
        };
        var flex = utils.sum(column.columns.map(function (col) {
          return col.width || resizedValue(col) ? 0 : col.minWidth;
        }));
        var width = utils.sum(column.columns.map(function (col) {
          return utils.getFirstDefined(resizedValue(col), col.width, col.minWidth);
        }));
        var maxWidth = utils.sum(column.columns.map(function (col) {
          return utils.getFirstDefined(resizedValue(col), col.width, col.maxWidth);
        }));

        var theadGroupThProps = utils.splitProps(getTheadGroupThProps(finalState, undefined, column, _this2));
        var columnHeaderProps = utils.splitProps(column.getHeaderProps(finalState, undefined, column, _this2));

        var classes = [column.headerClassName, theadGroupThProps.className, columnHeaderProps.className];

        var styles = es__extends({}, column.headerStyle, theadGroupThProps.style, columnHeaderProps.style);

        var rest = es__extends({}, theadGroupThProps.rest, columnHeaderProps.rest);

        var flexStyles = {
          flex: flex + ' 0 auto',
          width: utils.asPx(width),
          maxWidth: utils.asPx(maxWidth)
        };

        return preact_compat_es.createElement(ThComponent, es__extends({
          key: i + '-' + column.id,
          className: classnames_default()(classes),
          style: es__extends({}, styles, flexStyles)
        }, rest), utils.normalizeComponent(column.Header, {
          data: sortedData,
          column: column
        }));
      };

      var makeHeaderGroups = function makeHeaderGroups() {
        var theadGroupProps = utils.splitProps(getTheadGroupProps(finalState, undefined, undefined, _this2));
        var theadGroupTrProps = utils.splitProps(getTheadGroupTrProps(finalState, undefined, undefined, _this2));
        return preact_compat_es.createElement(TheadComponent, es__extends({
          className: classnames_default()('-headerGroups', theadGroupProps.className),
          style: es__extends({}, theadGroupProps.style, {
            minWidth: rowMinWidth + 'px'
          })
        }, theadGroupProps.rest), preact_compat_es.createElement(TrComponent, es__extends({
          className: theadGroupTrProps.className,
          style: theadGroupTrProps.style
        }, theadGroupTrProps.rest), headerGroups.map(makeHeaderGroup)));
      };

      var makeHeader = function makeHeader(column, i) {
        var resizedCol = resized.find(function (x) {
          return x.id === column.id;
        }) || {};
        var sort = sorted.find(function (d) {
          return d.id === column.id;
        });
        var show = typeof column.show === 'function' ? column.show() : column.show;
        var width = utils.getFirstDefined(resizedCol.value, column.width, column.minWidth);
        var maxWidth = utils.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
        var theadThProps = utils.splitProps(getTheadThProps(finalState, undefined, column, _this2));
        var columnHeaderProps = utils.splitProps(column.getHeaderProps(finalState, undefined, column, _this2));

        var classes = [column.headerClassName, theadThProps.className, columnHeaderProps.className];

        var styles = es__extends({}, column.headerStyle, theadThProps.style, columnHeaderProps.style);

        var rest = es__extends({}, theadThProps.rest, columnHeaderProps.rest);

        var isResizable = utils.getFirstDefined(column.resizable, resizable, false);
        var resizer = isResizable ? preact_compat_es.createElement(ResizerComponent, es__extends({
          onMouseDown: function onMouseDown(e) {
            return _this2.resizeColumnStart(e, column, false);
          },
          onTouchStart: function onTouchStart(e) {
            return _this2.resizeColumnStart(e, column, true);
          }
        }, getResizerProps('finalState', undefined, column, _this2))) : null;

        var isSortable = utils.getFirstDefined(column.sortable, sortable, false);

        return preact_compat_es.createElement(ThComponent, es__extends({
          key: i + '-' + column.id,
          className: classnames_default()(classes, isResizable && 'rt-resizable-header', sort ? sort.desc ? '-sort-desc' : '-sort-asc' : '', isSortable && '-cursor-pointer', !show && '-hidden', pivotBy && pivotBy.slice(0, -1).includes(column.id) && 'rt-header-pivot'),
          style: es__extends({}, styles, {
            flex: width + ' 0 auto',
            width: utils.asPx(width),
            maxWidth: utils.asPx(maxWidth)
          }),
          toggleSort: function toggleSort(e) {
            if (isSortable) _this2.sortColumn(column, multiSort ? e.shiftKey : false);
          }
        }, rest), preact_compat_es.createElement('div', { className: classnames_default()(isResizable && 'rt-resizable-header-content') }, utils.normalizeComponent(column.Header, {
          data: sortedData,
          column: column
        })), resizer);
      };

      var makeHeaders = function makeHeaders() {
        var theadProps = utils.splitProps(getTheadProps(finalState, undefined, undefined, _this2));
        var theadTrProps = utils.splitProps(getTheadTrProps(finalState, undefined, undefined, _this2));
        return preact_compat_es.createElement(TheadComponent, es__extends({
          className: classnames_default()('-header', theadProps.className),
          style: es__extends({}, theadProps.style, {
            minWidth: rowMinWidth + 'px'
          })
        }, theadProps.rest), preact_compat_es.createElement(TrComponent, es__extends({
          className: theadTrProps.className,
          style: theadTrProps.style
        }, theadTrProps.rest), allVisibleColumns.map(makeHeader)));
      };

      var makeFilter = function makeFilter(column, i) {
        var resizedCol = resized.find(function (x) {
          return x.id === column.id;
        }) || {};
        var width = utils.getFirstDefined(resizedCol.value, column.width, column.minWidth);
        var maxWidth = utils.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
        var theadFilterThProps = utils.splitProps(getTheadFilterThProps(finalState, undefined, column, _this2));
        var columnHeaderProps = utils.splitProps(column.getHeaderProps(finalState, undefined, column, _this2));

        var classes = [column.headerClassName, theadFilterThProps.className, columnHeaderProps.className];

        var styles = es__extends({}, column.headerStyle, theadFilterThProps.style, columnHeaderProps.style);

        var rest = es__extends({}, theadFilterThProps.rest, columnHeaderProps.rest);

        var filter = filtered.find(function (filter) {
          return filter.id === column.id;
        });

        var ResolvedFilterComponent = column.Filter || FilterComponent;

        var isFilterable = utils.getFirstDefined(column.filterable, filterable, false);

        return preact_compat_es.createElement(ThComponent, es__extends({
          key: i + '-' + column.id,
          className: classnames_default()(classes),
          style: es__extends({}, styles, {
            flex: width + ' 0 auto',
            width: utils.asPx(width),
            maxWidth: utils.asPx(maxWidth)
          })
        }, rest), isFilterable ? utils.normalizeComponent(ResolvedFilterComponent, {
          column: column,
          filter: filter,
          onChange: function onChange(value) {
            return _this2.filterColumn(column, value);
          }
        }, defaultProps.column.Filter) : null);
      };

      var makeFilters = function makeFilters() {
        var theadFilterProps = utils.splitProps(getTheadFilterProps(finalState, undefined, undefined, _this2));
        var theadFilterTrProps = utils.splitProps(getTheadFilterTrProps(finalState, undefined, undefined, _this2));
        return preact_compat_es.createElement(TheadComponent, es__extends({
          className: classnames_default()('-filters', theadFilterProps.className),
          style: es__extends({}, theadFilterProps.style, {
            minWidth: rowMinWidth + 'px'
          })
        }, theadFilterProps.rest), preact_compat_es.createElement(TrComponent, es__extends({
          className: theadFilterTrProps.className,
          style: theadFilterTrProps.style
        }, theadFilterTrProps.rest), allVisibleColumns.map(makeFilter)));
      };

      var makePageRow = function makePageRow(row, i) {
        var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

        var rowInfo = {
          original: row[originalKey],
          row: row,
          index: row[indexKey],
          viewIndex: rowIndex += 1,
          pageSize: pageSize,
          page: page,
          level: path.length,
          nestingPath: path.concat([i]),
          aggregated: row[aggregatedKey],
          groupedByPivot: row[groupedByPivotKey],
          subRows: row[subRowsKey]
        };
        var isExpanded = utils.get(expanded, rowInfo.nestingPath);
        var trGroupProps = getTrGroupProps(finalState, rowInfo, undefined, _this2);
        var trProps = utils.splitProps(getTrProps(finalState, rowInfo, undefined, _this2));
        return preact_compat_es.createElement(TrGroupComponent, es__extends({ key: rowInfo.nestingPath.join('_') }, trGroupProps), preact_compat_es.createElement(TrComponent, es__extends({
          className: classnames_default()(trProps.className, row._viewIndex % 2 ? '-even' : '-odd'),
          style: trProps.style
        }, trProps.rest), allVisibleColumns.map(function (column, i2) {
          var resizedCol = resized.find(function (x) {
            return x.id === column.id;
          }) || {};
          var show = typeof column.show === 'function' ? column.show() : column.show;
          var width = utils.getFirstDefined(resizedCol.value, column.width, column.minWidth);
          var maxWidth = utils.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
          var tdProps = utils.splitProps(getTdProps(finalState, rowInfo, column, _this2));
          var columnProps = utils.splitProps(column.getProps(finalState, rowInfo, column, _this2));

          var classes = [tdProps.className, column.className, columnProps.className];

          var styles = es__extends({}, tdProps.style, column.style, columnProps.style);

          var cellInfo = es__extends({}, rowInfo, {
            isExpanded: isExpanded,
            column: es__extends({}, column),
            value: rowInfo.row[column.id],
            pivoted: column.pivoted,
            expander: column.expander,
            resized: resized,
            show: show,
            width: width,
            maxWidth: maxWidth,
            tdProps: tdProps,
            columnProps: columnProps,
            classes: classes,
            styles: styles
          });

          var value = cellInfo.value;

          var useOnExpanderClick = void 0;
          var isBranch = void 0;
          var isPreview = void 0;

          var onExpanderClick = function onExpanderClick(e) {
            var newExpanded = utils.clone(expanded);
            if (isExpanded) {
              newExpanded = utils.set(newExpanded, cellInfo.nestingPath, false);
            } else {
              newExpanded = utils.set(newExpanded, cellInfo.nestingPath, {});
            }

            return _this2.setStateWithData({
              expanded: newExpanded
            }, function () {
              return onExpandedChange && onExpandedChange(newExpanded, cellInfo.nestingPath, e);
            });
          };

          // Default to a standard cell
          var resolvedCell = utils.normalizeComponent(column.Cell, cellInfo, value);

          // Resolve Renderers
          var ResolvedAggregatedComponent = column.Aggregated || (!column.aggregate ? AggregatedComponent : column.Cell);
          var ResolvedExpanderComponent = column.Expander || ExpanderComponent;
          var ResolvedPivotValueComponent = column.PivotValue || PivotValueComponent;
          var DefaultResolvedPivotComponent = PivotComponent || function (props) {
            return preact_compat_es.createElement('div', null, preact_compat_es.createElement(ResolvedExpanderComponent, props), preact_compat_es.createElement(ResolvedPivotValueComponent, props));
          };
          var ResolvedPivotComponent = column.Pivot || DefaultResolvedPivotComponent;

          // Is this cell expandable?
          if (cellInfo.pivoted || cellInfo.expander) {
            // Make it expandable by defualt
            cellInfo.expandable = true;
            useOnExpanderClick = true;
            // If pivoted, has no subRows, and does not have a subComponent,
            // do not make expandable
            if (cellInfo.pivoted && !cellInfo.subRows && !SubComponent) {
              cellInfo.expandable = false;
            }
          }

          if (cellInfo.pivoted) {
            // Is this column a branch?
            isBranch = rowInfo.row[pivotIDKey] === column.id && cellInfo.subRows;
            // Should this column be blank?
            isPreview = pivotBy.indexOf(column.id) > pivotBy.indexOf(rowInfo.row[pivotIDKey]) && cellInfo.subRows;
            // Pivot Cell Render Override
            if (isBranch) {
              // isPivot
              resolvedCell = utils.normalizeComponent(ResolvedPivotComponent, es__extends({}, cellInfo, {
                value: row[pivotValKey]
              }), row[pivotValKey]);
            } else if (isPreview) {
              // Show the pivot preview
              resolvedCell = utils.normalizeComponent(ResolvedAggregatedComponent, cellInfo, value);
            } else {
              resolvedCell = null;
            }
          } else if (cellInfo.aggregated) {
            resolvedCell = utils.normalizeComponent(ResolvedAggregatedComponent, cellInfo, value);
          }

          if (cellInfo.expander) {
            resolvedCell = utils.normalizeComponent(ResolvedExpanderComponent, cellInfo, row[pivotValKey]);
            if (pivotBy) {
              if (cellInfo.groupedByPivot) {
                resolvedCell = null;
              }
              if (!cellInfo.subRows && !SubComponent) {
                resolvedCell = null;
              }
            }
          }

          var resolvedOnExpanderClick = useOnExpanderClick ? onExpanderClick : function () {};

          // If there are multiple onClick events, make sure they don't
          // override eachother. This should maybe be expanded to handle all
          // function attributes
          var interactionProps = {
            onClick: resolvedOnExpanderClick
          };

          if (tdProps.rest.onClick) {
            interactionProps.onClick = function (e) {
              tdProps.rest.onClick(e, function () {
                return resolvedOnExpanderClick(e);
              });
            };
          }

          if (columnProps.rest.onClick) {
            interactionProps.onClick = function (e) {
              columnProps.rest.onClick(e, function () {
                return resolvedOnExpanderClick(e);
              });
            };
          }

          // Return the cell
          return preact_compat_es.createElement(TdComponent
          // eslint-disable-next-line react/no-array-index-key

          , es__extends({ key: i2 + '-' + column.id,
            className: classnames_default()(classes, !show && 'hidden', cellInfo.expandable && 'rt-expandable', (isBranch || isPreview) && 'rt-pivot'),
            style: es__extends({}, styles, {
              flex: width + ' 0 auto',
              width: utils.asPx(width),
              maxWidth: utils.asPx(maxWidth)
            })
          }, tdProps.rest, columnProps.rest, interactionProps), resolvedCell);
        })), rowInfo.subRows && isExpanded && rowInfo.subRows.map(function (d, i) {
          return makePageRow(d, i, rowInfo.nestingPath);
        }), SubComponent && !rowInfo.subRows && isExpanded && SubComponent(rowInfo));
      };

      var makePadColumn = function makePadColumn(column, i) {
        var resizedCol = resized.find(function (x) {
          return x.id === column.id;
        }) || {};
        var show = typeof column.show === 'function' ? column.show() : column.show;
        var width = utils.getFirstDefined(resizedCol.value, column.width, column.minWidth);
        var flex = width;
        var maxWidth = utils.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
        var tdProps = utils.splitProps(getTdProps(finalState, undefined, column, _this2));
        var columnProps = utils.splitProps(column.getProps(finalState, undefined, column, _this2));

        var classes = [tdProps.className, column.className, columnProps.className];

        var styles = es__extends({}, tdProps.style, column.style, columnProps.style);

        return preact_compat_es.createElement(TdComponent, es__extends({
          key: i + '-' + column.id,
          className: classnames_default()(classes, !show && 'hidden'),
          style: es__extends({}, styles, {
            flex: flex + ' 0 auto',
            width: utils.asPx(width),
            maxWidth: utils.asPx(maxWidth)
          })
        }, tdProps.rest), utils.normalizeComponent(PadRowComponent));
      };

      var makePadRow = function makePadRow(row, i) {
        var trGroupProps = getTrGroupProps(finalState, undefined, undefined, _this2);
        var trProps = utils.splitProps(getTrProps(finalState, undefined, undefined, _this2));
        return preact_compat_es.createElement(TrGroupComponent, es__extends({ key: i }, trGroupProps), preact_compat_es.createElement(TrComponent, {
          className: classnames_default()('-padRow', (pageRows.length + i) % 2 ? '-even' : '-odd', trProps.className),
          style: trProps.style || {}
        }, allVisibleColumns.map(makePadColumn)));
      };

      var makeColumnFooter = function makeColumnFooter(column, i) {
        var resizedCol = resized.find(function (x) {
          return x.id === column.id;
        }) || {};
        var show = typeof column.show === 'function' ? column.show() : column.show;
        var width = utils.getFirstDefined(resizedCol.value, column.width, column.minWidth);
        var maxWidth = utils.getFirstDefined(resizedCol.value, column.width, column.maxWidth);
        var tFootTdProps = utils.splitProps(getTfootTdProps(finalState, undefined, undefined, _this2));
        var columnProps = utils.splitProps(column.getProps(finalState, undefined, column, _this2));
        var columnFooterProps = utils.splitProps(column.getFooterProps(finalState, undefined, column, _this2));

        var classes = [tFootTdProps.className, column.className, columnProps.className, columnFooterProps.className];

        var styles = es__extends({}, tFootTdProps.style, column.style, columnProps.style, columnFooterProps.style);

        return preact_compat_es.createElement(TdComponent, es__extends({
          key: i + '-' + column.id,
          className: classnames_default()(classes, !show && 'hidden'),
          style: es__extends({}, styles, {
            flex: width + ' 0 auto',
            width: utils.asPx(width),
            maxWidth: utils.asPx(maxWidth)
          })
        }, columnProps.rest, tFootTdProps.rest, columnFooterProps.rest), utils.normalizeComponent(column.Footer, {
          data: sortedData,
          column: column
        }));
      };

      var makeColumnFooters = function makeColumnFooters() {
        var tFootProps = getTfootProps(finalState, undefined, undefined, _this2);
        var tFootTrProps = utils.splitProps(getTfootTrProps(finalState, undefined, undefined, _this2));
        return preact_compat_es.createElement(TfootComponent, es__extends({
          className: tFootProps.className,
          style: es__extends({}, tFootProps.style, {
            minWidth: rowMinWidth + 'px'
          })
        }, tFootProps.rest), preact_compat_es.createElement(TrComponent, es__extends({
          className: classnames_default()(tFootTrProps.className),
          style: tFootTrProps.style
        }, tFootTrProps.rest), allVisibleColumns.map(makeColumnFooter)));
      };

      var makePagination = function makePagination() {
        var paginationProps = utils.splitProps(getPaginationProps(finalState, undefined, undefined, _this2));
        return preact_compat_es.createElement(PaginationComponent, es__extends({}, resolvedState, {
          pages: pages,
          canPrevious: canPrevious,
          canNext: canNext,
          onPageChange: _this2.onPageChange,
          onPageSizeChange: _this2.onPageSizeChange,
          className: paginationProps.className,
          style: paginationProps.style
        }, paginationProps.rest));
      };

      var makeTable = function makeTable() {
        var pagination = makePagination();
        return preact_compat_es.createElement('div', es__extends({
          className: classnames_default()('ReactTable', className, rootProps.className),
          style: es__extends({}, style, rootProps.style)
        }, rootProps.rest), showPagination && showPaginationTop ? preact_compat_es.createElement('div', { className: 'pagination-top' }, pagination) : null, preact_compat_es.createElement(TableComponent, es__extends({
          className: classnames_default()(tableProps.className, currentlyResizing ? 'rt-resizing' : ''),
          style: tableProps.style
        }, tableProps.rest), hasHeaderGroups ? makeHeaderGroups() : null, makeHeaders(), hasFilters ? makeFilters() : null, preact_compat_es.createElement(TbodyComponent, es__extends({
          className: classnames_default()(tBodyProps.className),
          style: es__extends({}, tBodyProps.style, {
            minWidth: rowMinWidth + 'px'
          })
        }, tBodyProps.rest), pageRows.map(function (d, i) {
          return makePageRow(d, i);
        }), padRows.map(makePadRow)), hasColumnFooter ? makeColumnFooters() : null), showPagination && showPaginationBottom ? preact_compat_es.createElement('div', { className: 'pagination-bottom' }, pagination) : null, !pageRows.length && preact_compat_es.createElement(NoDataComponent, noDataProps, utils.normalizeComponent(noDataText)), preact_compat_es.createElement(LoadingComponent, es__extends({ loading: loading, loadingText: loadingText }, loadingProps)));
      };

      // childProps are optionally passed to a function-as-a-child
      return children ? children(finalState, makeTable, this) : makeTable();
    }
  }]);

  return ReactTable;
}(methods(lifecycle(Component$1)));

es_ReactTable.defaultProps = defaultProps;
/* harmony default export */ var es = (es_ReactTable);
// CONCATENATED MODULE: ./components/download-button.js


var download_button__ref2 = Object(preact_min["h"])(
	"svg",
	{ xmlns: "http://www.w3.org/2000/svg", fill: "#fff", width: "32", height: "32", viewBox: "0 0 24 24" },
	Object(preact_min["h"])("path", { d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z" }),
	Object(preact_min["h"])("path", { fill: "none", d: "M0 0h24v24H0z" })
);

function DownloadButton(_ref) {
	var onClick = _ref.onClick,
	    disabled = _ref.disabled;

	return Object(preact_min["h"])(
		"button",
		{ onClick: onClick, disabled: disabled, "class": "download", title: "Download stats table", role: "button" },
		download_button__ref2
	);
}
// EXTERNAL MODULE: ../node_modules/react-table/react-table.css
var react_table = __webpack_require__("6N6E");
var react_table_default = /*#__PURE__*/__webpack_require__.n(react_table);

// EXTERNAL MODULE: ./styles/table.css
var table = __webpack_require__("crML");
var table_default = /*#__PURE__*/__webpack_require__.n(table);

// CONCATENATED MODULE: ./components/stats-table.js


function stats_table__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function stats_table__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function stats_table__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var stats_table_StatsTable = function (_Component) {
	stats_table__inherits(StatsTable, _Component);

	function StatsTable() {
		var _temp, _this, _ret;

		stats_table__classCallCheck(this, StatsTable);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = stats_table__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
			maxHeight: 0
		}, _this.tableRef = null, _this.columns = [{
			Header: 'Rule index',
			accessor: 'ruleIndex',
			Cell: function Cell(row) {
				return Object(preact_min["h"])(TableItemNumber, { value: row.value, numberFormat: _this.props.numberFormat });
			}
		}, {
			Header: 'Filename',
			accessor: 'filename',
			Cell: function Cell(row) {
				return Object(preact_min["h"])(
					'span',
					{ 'class': row.value || 'bold', title: row.value },
					row.value || '-'
				);
			}
		}, {
			Header: 'Line number',
			accessor: 'lineNumber',
			Cell: function Cell(row) {
				return Object(preact_min["h"])(TableItemNumber, { value: row.value, numberFormat: _this.props.numberFormat });
			}
		}, {
			Header: 'Relationship',
			accessor: 'relationship',
			width: 250,
			Cell: function Cell(row) {
				return Object(preact_min["h"])(
					'span',
					{ title: row.value },
					row.value
				);
			}
		}, {
			Header: 'Calls',
			accessor: 'calls',
			Cell: function Cell(row) {
				return Object(preact_min["h"])(TableItemNumber, { value: row.value, numberFormat: _this.props.numberFormat });
			}
		}, {
			Header: 'Total time',
			accessor: 'totalTime',
			Cell: function Cell(row) {
				return Object(preact_min["h"])(TableItemTime, { value: row.value, numberFormat: _this.props.numberFormat });
			}
		}, {
			Header: 'Average time',
			accessor: 'averageTime',
			Cell: function Cell(row) {
				return Object(preact_min["h"])(TableItemTime, { value: row.value, numberFormat: _this.props.numberFormat });
			}
		}], _this.updateMaxHeight = function () {
			var height = _this.tableRef.clientHeight;
			if (height > _this.state.maxHeight) {
				_this.setState({
					maxHeight: height
				});
			}
		}, _this.onDownloadClick = function () {
			var headers = _this.columns.map(function (c) {
				return c.Header;
			}).join(',');
			var accessors = _this.columns.map(function (c) {
				return c.accessor;
			});

			var csv = _this.props.stats.map(function (stat) {
				return accessors.map(function (accessor) {
					return stat[accessor] || '';
				}).join(',');
			}).join('\n');

			var csvBlob = new Blob([headers + '\n' + csv]);

			var downloadUrl = URL.createObjectURL(csvBlob);
			var link = document.createElement('a');
			link.href = downloadUrl;
			link.download = 'rainbird-rule-stats.csv';
			document.body.appendChild(link);
			link.click();
			document.removeChild(link);
		}, _temp), stats_table__possibleConstructorReturn(_this, _ret);
	}

	StatsTable.prototype.componentDidMount = function componentDidMount() {
		this.updateMaxHeight();
	};

	StatsTable.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updateMaxHeight();
	};

	StatsTable.prototype.render = function render() {
		var _this2 = this;

		return Object(preact_min["h"])(
			'div',
			{ ref: function ref(_ref) {
					return _this2.tableRef = _ref;
				}, style: { minHeight: this.state.maxHeight } },
			Object(preact_min["h"])(
				'h2',
				null,
				'Rule Stats',
				Object(preact_min["h"])(DownloadButton, { disabled: !this.props.stats.length, onClick: this.onDownloadClick })
			),
			Object(preact_min["h"])(es, {
				data: this.props.stats,
				minRows: 0,
				filterable: true,
				className: '-striped -highlight',
				onPageChange: this.updateMaxHeight,
				onPageSizeChange: this.updateMaxHeight,
				onFilteredChange: this.updateMaxHeight,
				columns: this.columns
			})
		);
	};

	return StatsTable;
}(preact_min["Component"]);
// EXTERNAL MODULE: ../node_modules/d3-flame-graph/src/flamegraph.css
var flamegraph = __webpack_require__("lo6h");
var flamegraph_default = /*#__PURE__*/__webpack_require__.n(flamegraph);

// CONCATENATED MODULE: ./components/flamegraph.js


function flamegraph__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function flamegraph__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function flamegraph__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


var flamegraph_flamegraph = void 0;
var d3 = void 0;
var tip = void 0;



var flamegraph_FlameGraph = function (_Component) {
	flamegraph__inherits(FlameGraph, _Component);

	function FlameGraph() {
		var _temp, _this, _ret;

		flamegraph__classCallCheck(this, FlameGraph);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = flamegraph__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
			d3Select: null,
			tooltip: null,
			graph: null
		}, _this.chartRef = null, _temp), flamegraph__possibleConstructorReturn(_this, _ret);
	}

	FlameGraph.prototype.setStateAsync = function setStateAsync(state) {
		var _this2 = this;

		return new Promise(function (resolve) {
			_this2.setState(state, resolve);
		});
	};

	FlameGraph.prototype.componentDidUpdate = function componentDidUpdate() {
		return new Promise(function ($return, $error) {
			var tooltip, rootColour;

			if (typeof window === 'undefined') return $return();

			return Promise.resolve(importModules()).then(function ($await_3) {
				try {

					if (!this.state.tooltip || !this.state.graph) {
						tooltip = tip().attr('class', 'd3-flame-graph-tip').html(function (_ref) {
							var data = _ref.data;
							return createTipMarkup(data);
						});

						return Promise.resolve(this.setStateAsync({
							d3Select: d3.select('#chart'),
							tooltip: tooltip,
							graph: flamegraph_flamegraph().width(this.chartRef.clientWidth).tooltip(tooltip)
						})).then(function ($await_4) {
							try {
								return $If_1.call(this);
							} catch ($boundEx) {
								return $error($boundEx);
							}
						}.bind(this), $error);
					}

					function $If_1() {
						if (this.state.d3Select && this.props.data.children) {
							this.state.graph.height(0);
							rootColour = '#ff6e00';
							this.state.d3Select.datum(this.props.data).call(this.state.graph.setColorMapper(function (node) {
								return node.data.filename ? node.data.color : rootColour;
							}));
						}
						return $return();
					}

					return $If_1.call(this);
				} catch ($boundEx) {
					return $error($boundEx);
				}
			}.bind(this), $error);
		}.bind(this));
	};

	FlameGraph.prototype.render = function render() {
		var _this3 = this;

		return Object(preact_min["h"])(
			'div',
			{ 'class': 'column' },
			Object(preact_min["h"])('div', {
				'class': 'chart',
				id: 'chart',
				ref: function ref(_ref2) {
					return _this3.chartRef = _ref2;
				}
			})
		);
	};

	return FlameGraph;
}(preact_min["Component"]);

function importModules() {
	return new Promise(function ($return, $error) {
		var imports;

		if (!flamegraph_flamegraph || !d3 || !tip) {
			return Promise.resolve(Promise.all([__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "UzF0")), __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "2L7n")), __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "0s9i"))])).then(function ($await_5) {
				try {
					imports = $await_5;

					d3 = imports[0];
					tip = imports[1].default;
					flamegraph_flamegraph = imports[2].flamegraph;
					return $If_2.call(this);
				} catch ($boundEx) {
					return $error($boundEx);
				}
			}.bind(this), $error);
		}

		function $If_2() {
			return $return();
		}

		return $If_2.call(this);
	});
}

// Some non react markup building to be passed into D3's tooltip module.
function createTipMarkup(data) {
	var markup = '';
	if (data.name) {
		markup += data.name;
	} else {
		markup += 'root';
	}

	if (data.lineNumber) {
		markup += ':' + data.lineNumber;
	}

	markup += '<br />Time: ' + (data.value / 1000000).toFixed(2) + 'ms';

	if (data.filename) {
		markup += '<br />File: ' + data.filename;
	}

	return markup;
}
// EXTERNAL MODULE: ./styles/flamegraph-legend.css
var flamegraph_legend = __webpack_require__("gWwa");
var flamegraph_legend_default = /*#__PURE__*/__webpack_require__.n(flamegraph_legend);

// CONCATENATED MODULE: ./components/flamegraph-legend.js




function FlamegraphLegend(_ref) {
  var data = _ref.data;

  return Object(preact_min["h"])(
    'div',
    { 'class': 'legend' },
    data && Object.keys(data).length > 1 ? Object.entries(data).map(function (_ref2, i) {
      var label = _ref2[0],
          color = _ref2[1];
      return Object(preact_min["h"])(FlamegraphItem, { key: i, color: color, label: label });
    }) : null
  );
}

function FlamegraphItem(_ref3) {
  var color = _ref3.color,
      label = _ref3.label;

  return Object(preact_min["h"])(
    'span',
    { 'class': 'legend-entry' },
    Object(preact_min["h"])('span', { 'class': 'legend-swatch', style: { background: hslToHex(color, 100, 50) } }),
    Object(preact_min["h"])(
      'span',
      null,
      label
    )
  );
}
// CONCATENATED MODULE: ./components/rule-profiler.js
var rule_profiler__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function rule_profiler__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function rule_profiler__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function rule_profiler__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function rule_profiler__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var rule_profiler_RuleProfiler = function (_Component) {
	rule_profiler__inherits(RuleProfiler, _Component);

	function RuleProfiler() {
		var _temp, _this, _ret;

		rule_profiler__classCallCheck(this, RuleProfiler);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = rule_profiler__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
			ruleData: {},
			hueMap: {},
			stats: [],
			sid: null,
			summary: null,
			queryProfile: {},
			numberFormat: null
		}, _this.handleJsonChange = function (event) {
			var data = null;
			try {
				data = JSON.parse(event.target.value);
			} catch (err) {
				console.error(err);
			}

			if (typeof data !== 'object' || data === null) {
				_this.setState({
					ruleData: {},
					hueMap: {},
					stats: [],
					sid: null,
					summary: null,
					queryProfile: {}
				});
				return;
			}

			var _processRuleData = processRuleData(data.queryProfile),
			    stats = _processRuleData.stats,
			    ruleData = _processRuleData.ruleData,
			    hueMap = _processRuleData.hueMap;

			var summary = data.result ? {
				totalMs: data.stats.totalMS,
				engineTime: data.stats.approxEngineMS,
				totalConditionCount: data.stats.totalConditionCount,
				callDatasourceCount: data.stats.callDatasource.calls,
				callDatasourceTime: data.stats.callDatasource.ms
			} : {};

			if (Array.isArray(data.result) && data.result > 0) {
				summary.evidenceTree = 'https://app.rainbird.ai/applications/components/rainbird-analysis-ui/whyAnalysis.html?id=' + data.result[0].factID + '?api=https://api.rainbird.ai';
			}

			_this.setState({
				ruleData: ruleData,
				stats: stats.sort(function (a, b) {
					return b.totalTime - a.totalTime;
				}),
				sid: data.sid,
				summary: summary,
				hueMap: hueMap
			});
		}, _temp), rule_profiler__possibleConstructorReturn(_this, _ret);
	}

	RuleProfiler.prototype.componentDidMount = function componentDidMount() {
		var _props$numberFormat = this.props.numberFormat,
		    locales = _props$numberFormat.locales,
		    options = rule_profiler__objectWithoutProperties(_props$numberFormat, ['locales']);

		this.setState({
			numberFormat: new Intl.NumberFormat(locales, options)
		});
	};

	RuleProfiler.prototype.shouldComponentUpdate = function shouldComponentUpdate(_, nextState) {
		return typeof nextState.ruleData === 'object' && Array.isArray(nextState.ruleData.children) && nextState.ruleData.children.length > 0 && nextState.sid !== this.state.sid;
	};

	RuleProfiler.prototype.render = function render() {
		return Object(preact_min["h"])(
			'div',
			null,
			Object(preact_min["h"])(
				'div',
				{ 'class': 'row' },
				Object(preact_min["h"])(
					'div',
					{ 'class': 'column' },
					Object(preact_min["h"])(JsonInput, { placeHolder: 'Paste JSON here...', handleJsonChange: this.handleJsonChange })
				),
				Object(preact_min["h"])(
					'div',
					{ 'class': 'column' },
					Object(preact_min["h"])(SummaryTable, rule_profiler__extends({}, this.state.summary, { numberFormat: this.state.numberFormat }))
				)
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': 'row' },
				Object(preact_min["h"])(flamegraph_FlameGraph, { data: this.state.ruleData })
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': 'row legend-row' },
				Object(preact_min["h"])(
					'div',
					{ 'class': 'column' },
					Object(preact_min["h"])(FlamegraphLegend, { data: this.state.hueMap })
				)
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': 'row stats' },
				Object(preact_min["h"])(
					'div',
					{ 'class': 'column' },
					Object(preact_min["h"])(stats_table_StatsTable, { numberFormat: this.state.numberFormat, stats: this.state.stats })
				)
			)
		);
	};

	return RuleProfiler;
}(preact_min["Component"]);

function processRuleData(profile) {
	var stats = [];
	var hueMap = {};
	var fallbackColour = '#b3b3b3';
	var hues = circularIterator([26, 57, 216, 297, 177]);
	var ruleData = {
		children: nextChildren([], profile),
		value: computeTimeSum(0, profile)
	};

	for (var _iterator = stats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		var _ref;

		if (_isArray) {
			if (_i >= _iterator.length) break;
			_ref = _iterator[_i++];
		} else {
			_i = _iterator.next();
			if (_i.done) break;
			_ref = _i.value;
		}

		var stat = _ref;

		stat.averageTime = stat.totalTime / stat.calls;
	}

	return { stats: stats, ruleData: ruleData, hueMap: hueMap };

	function nextChildren(children, profile) {
		if (!profile) return;
		profile.forEach(function (rule) {
			recordStat(rule);
			var relationship = rule.relationship,
			    ruleIndex = rule.ruleIndex,
			    lineNumber = rule.lineNumber,
			    totalTime = rule.totalTime,
			    calledRules = rule.calledRules,
			    filename = rule.filename;

			var summedTime = computeTimeSum(totalTime.nanoseconds, calledRules);
			var obj = {
				name: relationship,
				value: summedTime,
				ruleIndex: ruleIndex,
				lineNumber: lineNumber,
				filename: filename,
				children: []
			};

			if (!filename) {
				obj.color = fallbackColour;
			} else if (hueMap[filename]) {
				obj.color = hslToHex.apply(undefined, randomHsl(hueMap[filename]));
			} else {
				var hue = hues.next().value;
				hueMap[filename] = hue;
				obj.color = hslToHex.apply(undefined, randomHsl(hue));
			}

			obj.children = nextChildren(obj.children, calledRules);
			children.push(obj);
		});
		return children;
	}
	function recordStat(_ref2) {
		var relationship = _ref2.relationship,
		    ruleIndex = _ref2.ruleIndex,
		    lineNumber = _ref2.lineNumber,
		    totalTime = _ref2.totalTime,
		    callCount = _ref2.callCount,
		    filename = _ref2.filename;

		var stat = stats.find(function (stat) {
			return stat.ruleIndex === ruleIndex && stat.filename === filename;
		});
		if (!stat) {
			stats.push({
				relationship: relationship,
				ruleIndex: ruleIndex,
				lineNumber: lineNumber,
				filename: filename,
				totalTime: totalTime.nanoseconds,
				calls: callCount
			});
		} else {
			stat.calls = stat.calls + callCount;
			stat.totalTime = stat.totalTime + totalTime.nanoseconds;
		}
	}
}

function computeTimeSum(ruleTime, calledRules) {
	if (calledRules.length === 0) return ruleTime;
	var sum = ruleTime;
	calledRules.forEach(function (calledRule) {
		sum += computeTimeSum(calledRule.totalTime.nanoseconds, calledRule.calledRules);
	});
	return sum;
}

function randomHsl(hue) {
	return [hue, 100, randomLightness()];
}

function randomLightness() {
	var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	    _ref3$lowerBound = _ref3.lowerBound,
	    lowerBound = _ref3$lowerBound === undefined ? 35 : _ref3$lowerBound,
	    _ref3$upperBound = _ref3.upperBound,
	    upperBound = _ref3$upperBound === undefined ? 65 : _ref3$upperBound;

	var numberOfPossibleValues = upperBound - lowerBound + 1;
	return Math.floor(Math.random() * numberOfPossibleValues + lowerBound);
}

function circularIterator(arr) {
	var index = -1;
	var elements = Array.isArray(arr) ? arr.slice() : [];
	var length = elements.length;

	var iterator = {
		next: function next() {
			if (length) {
				index = (index + 1) % length;
				return { value: elements[index], done: false };
			}
		}
	};

	return iterator;
}
// CONCATENATED MODULE: ./index.js
/* harmony export (immutable) */ __webpack_exports__["default"] = App;





var index__ref = Object(preact_min["h"])(GithubBanner, null);

var index__ref2 = Object(preact_min["h"])(
	'h1',
	null,
	'Rainbird Rule Profiler'
);

function App() {
	return Object(preact_min["h"])(
		'div',
		null,
		index__ref,
		Object(preact_min["h"])(
			'div',
			{ 'class': 'container' },
			index__ref2,
			Object(preact_min["h"])(rule_profiler_RuleProfiler, { numberFormat: { locales: 'en-IN', maximumFractionDigits: 2 } })
		)
	);
}

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    null != e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "VSpX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "crML":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e1Qo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gWwa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lo6h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "wVGV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("Asjh");

function emptyFunction() {}

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.4be59.js